import {
	mapState
} from 'vuex'
import time from "js-time.js";
import {
	jsonToParams,
	fmoney,
	getCalorie,
	getDistance,
	getEggNum,
	getCircleNum,
	getLimits,
	stringToTimestamp,
	getTypeTime,
	getTypeTimeLanguage,
	xAxisComputeNibpReport,
	xAxisComputeSleepReport,
	xAxisComputeSportHrReport,
	xAxisComputeSportHrTimemapReport,
	xAxisComputeSportHrHexReport,
	xAxisCompute,
	xAxisCompute2,
	yAxisCompute,
	yAxisCompute2,
	remToPx,
	arrAv,
	getYAxiosArr,
	getYearDayNum,
	getMonthDayNum,
	getMinBySecondStr,
	getMinBySecondNoHourStr,
	getSecondBySecondStr
} from "@/utils/methods.js"
import {
	loginAccount,
	deleteAccount,
	getTrend,
	getTrendType,
	getStatistics,
	getPressDataList,
	getSleepReport,
	getStepListData,
	getSportListData,
	getSportDetailData,
	getSportDetailListData,
	getBOPercentage,
	getBOPercentageType,
	getNewReportTrend,
	getNewReportMonthData,
	getNewReportDayData,
	getMeasureDataDayList,
	getNibpReportHistoryListData,
	updateNibpReportApplyFailData,
	getNibpReportDetailData
} from '@/api/api.js';


// console.log("document.body.clientWidth: ",document.body.clientWidth);
let isWidthScreen = document.body.clientWidth > 800; // 是否是宽屏


export default {
	data() {
		return {
			pageNum:20,
			clientWidth: document.body.clientWidth,
			canvasWidth: isWidthScreen ? remToPx(25 - 3 - 3) - 60 : remToPx(25 - 3 - 3) - 30,
			canvasHeight: isWidthScreen ? 500 : 250, // 画图组件统一的默认高度
			canvasPadding: isWidthScreen ? ['0px', '60px', '60px', '0px'] : ['0px', '30px', '30px', '0px'],
			canvasLineWidth: isWidthScreen ? 12 : 6, // 线宽，统一各个绘图线宽
			radiusNum: isWidthScreen ? 32 : 16, // 血压中的圆点
			radius: isWidthScreen ? 100 : 50, // 血氧中的圆

			red: '#f82828',
			green3:'#00cf66',
			red1:'#E40000',
			lightRed: '#fe8888',
			lightRed2: '#fed5d5',
			lightRed3: '#f96565',
			gray: '#dfdfdf',
			gray2: '#999999',
			deepSleepColor: '#9447E3',//深睡
			lightSleepColor: '#cF61FF',//浅睡    '#B56AFA'
			remSleepColor: '#FC7474',//快速眼动
			noSleepColor: '#F6C020',//清醒
			smallSleepColor: '#0290F6',//零星小睡

			sportHrWarmupColor: '#35AAF0',//热身
			sportHrFatburningColor: '#4AC29E',//燃脂
			sportHrAerobicColor: '#FDC056',//有氧耐力
			sportHrAnaerobicColor: '#F58E87',//无氧耐力
			sportHrLimitColor: '#F35F55',//极限
			yellowColor: '#f1bc37',
			green: 'rgba(26,173,25,1)',
			lightGreen: '#87d687', // '#87d687'  'rgba(26,173,25,0.4)'
			green2: '#5cb180',
			lightGreen2: '#b8dec8', // '#87d687'  'rgba(26,173,25,0.4)'
			lightGreen3: '#63b62f',
			blue: '#4987c4',
			lightBlue: '#33BEFF', // '#87d687'  'rgba(26,173,25,0.4)'
			newTime: new Date().getTime(), // 当前时间
			pieColor: '#a5f965',
			colorArr: ['#dfdfdf', '#fe8888', '#999999', '#f82828','#EOEOEO','#00CF66'],

			dayStepSum: 0, // 日 总步数


			// 重新渲染时使用
			SNCanvasOnoff: true, // 步数
			BPCanvasOnoff: true, // 血压
			BOCanvasOnoff: true, // 血氧
			BOCSCanvasOnoff: true, // 血氧
			HRCanvasOnoff: true, // 心率
			HRCSCanvasOnoff: true, // 心率
			PCanvasOnoff: true, // 压力
			TCanvasOnoff: true, // 温度
			SleepCanvasOnoff: true, // 睡眠
			HRSportCanvasOnoff: true, // 运动心率
			StepSportCanvasOnoff: true, // 运动步频
			PaceSportCanvasOnoff: true, // 运动配速
			// 画图点集
			/*dots:[
				{  x:10, y:50, y2:100  },
				{  x:60, y:50, y2:200  },
				{  x:62, y:50, y2:200  },
				{  x:66, y:50, y2:200  },
				{  x:71, y:50, y2:200  },
				{  x:68, y:50, y2:200  },
				{  x:80, y:50, y2:200  },
				{  x:110, y:50, y2:200  },
				{  x:150, y:50, y2:200  },
				{  x:152, y:50, y2:200  },
				{  x:144, y:50, y2:200  },
				{  x:180, y:50, y2:200  },
			],*/
			SNDots: [],
			BPDots: [],
			BODots: [],
			BOLimits:{
				minBO:0,
				maxBO:0,
			},
			BOCSDots: [],
			BOCSLimits:{
				minBO:0,
				maxBO:0,
			},
			HRDots: [],
			HRCSDots: [],
			SleepDots: [],
			SleepReport: {
				yLimit: [0, 2, 4, 6, 8, 10, 12],
				sleepTimeSecond: 0,
				deepSleepSecond: 0,
				lightSleepSecond: 0,
				remSleepSecond: 0,
				sleepContinue: 0,
				sleepWakeNum: 0,
				sleepBreath: 0,
				sleepBeginPercent: 0,
				sleepBeginTime: 0,
				sleepEndPercent: 0,
				sleepEndTime: 0,
			},
			sportReportLocationDots:[],//运动定位轨迹点
			sportReportDetailData:{//运动报告详情数据
			},

			PDots: [
				/* {
					jsyl: 70      精神压力
					kynl: 98      抗压能力
					period: "202101"
					tired: 18     疲劳度
					ylzs: 59      压力指数
				} */
			],
			TDots: [],

			SNDotsOld: [], // 原始数据，画图y轴标量最大值随机改变
			BODotsOld: [],
			BOCSDotsOld: [],
			HRDotsOld: [],
			HRCSDotsOld: [],
			PDotsOld: [],
			TDotsOld: [],

			// allDots:[],   // 点钟的所有值（平均值、最大值、最小值、值）


			// 时间组件，自定义事件返回的数据
			returnTime: {}, // 时间组件返回的数据  {  newTime, startTime, endTime, type  }

			// returnData:{},   // 血压需要的返回值  {  x, y, y2  }
			returnDataSN: {}, // 步数需要的返回值  {  x, y, y2  }
			returnDataBP: {}, // 血压需要的返回值  {  x, y, y2  }
			returnDataBO: {}, // 血氧需要的返回值  {  x, y, y2  }
			returnDataCSBO: {}, // 血氧需要的返回值  {  x, y, y2  }
			returnDataHR: {}, // 心率需要的返回值  {  x, y, y2  }
			returnDataCSHR: {}, // 心率需要的返回值  {  x, y, y2  }
			returnDataP: {}, // 心率需要的返回值  {  x, y, y2  }
			returnDataT: {}, // 心率需要的返回值  {  x, y, y2  }
			returnDataSleep: {}, // 睡眠需要的返回值  {  x, y, y1,y2,y3,y4,y5,y6  }
			returnDataSportHR: {}, //运动心率需要返回值
			returnDataSportStep: {}, //运动步频需要返回值
			returnDataSportPace: {}, //运动配速需要返回值

			nibpReportDetailData: {},
			nibpReportDetailDataColor: {
				isHideNibpStatusAnd: true,
				totalStatusColor: '',
				time6to8countStatusColor: '',
				time17to19countStatusColor: '',
				time20to24countStatusColor: '',
				allNibpStatusColor: '',
				normalHighStatusColor: '',
				highStatusColor: '',
				oneLevelStatusColor: '',
				twoLevelStatusColor: '',

				allNibpStatisticsColor: '',
				sysStatusColor: '',
				diaStatusColor: '',
				maxMinSysStatusColor: '',
				maxMinDiaStatusColor: '',

				sysLoadDayTimeStatusColor: '', //0正常1异常  白天
				diaLoadDayTimeStatusColor: '', //0正常1异常 白天
				sysLoadNightStatusColor: '', //0正常1异常
				diaLoadNightStatusColor: '', //0正常1异常
				sysLoad24hStatusColor: '', //0正常1异常
				diaLoad24hStatusColor: '', //0正常1异常
				nightSysDecRateStatusColor: '',
				nightDiaDecRateStatusColor: '',
				avgDongMaiStatusColor: '',
				sysCvDayTimeStatusColor: '', //0正常1异常  白天
				diaCvDayTimeStatusColor: '', //0正常1异常 白天
				sysCvNightStatusColor: '', //0正常1异常
				diaCvNightStatusColor: '', //0正常1异常
				sysCv24hStatusColor: '', //0正常1异常
				diaCv24hStatusColor: '', //0正常1异常 
			},
			pressDataListData: {
				dataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				dataJson:[]
			},
			stepDataListData: {
				dataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				dataJson:[]
			},
			sportMonthListData: {
				monthDataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				MonthDataListJson: [],
			},
			// 血压统计meaStatist
			nibpReportListJson: {},
			BOListData: {
				dayDataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				dayDataListJson: [],
			},
			HrListData: {
				dayDataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				dayDataListJson: [],
			},
			TemperatureListData: {
				dayDataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				dayDataListJson: [],
			},
			monthListData: {
				monthDataSize: 0,
				isLoading: true,
				isNoData: false, // 没有数据
				isPullDown: false,
				isShowBottom: false,
				isBottomNoMore: false,
				lastTimeFormat: '',
				MonthDataListJson: [],
			},
			nibpDayListData: {
				isLoading: true,
				isNoData: false, // 没有数据
				dayListJson: [],
			},

			// nibpMeaStatisticsColor: {
			// 	totalStatusColor: '',
			// 	time6to8countStatusColor: '',
			// 	time17to19countStatusColor: '',
			// 	time20to24countStatusColor: '',
			// 	allNibpStatusColor: '',
			// 	normalHighStatusColor: '',
			// 	highStatusColor: '',
			// 	oneLevelStatusColor: '',
			// 	twoLevelStatusColor: '',
			// 	allNibpStatisticsColor: '',
			// 	sysStatusColor: '',
			// 	diaStatusColor: '',
			// 	maxMinSysStatusColor: '',
			// 	maxMinDiaStatusColor: '',

			// 	sysLoadDayTimeStatusColor: '', //0正常1异常  白天
			// 	diaLoadDayTimeStatusColor: '', //0正常1异常 白天
			// 	sysLoadNightStatusColor: '', //0正常1异常
			// 	diaLoadNightStatusColor: '', //0正常1异常
			// 	sysLoad24hStatusColor: '', //0正常1异常
			// 	diaLoad24hStatusColor: '', //0正常1异常


			// 	nightSysDecRateStatusColor: '',
			// 	nightDiaDecRateStatusColor: '',

			// 	avgDongMaiStatusColor: '',

			// 	sysCvDayTimeStatusColor: '', //0正常1异常  白天
			// 	diaCvDayTimeStatusColor: '', //0正常1异常 白天
			// 	sysCvNightStatusColor: '', //0正常1异常
			// 	diaCvNightStatusColor: '', //0正常1异常
			// 	sysCv24hStatusColor: '', //0正常1异常
			// 	diaCv24hStatusColor: '', //0正常1异常 
			// },
			nibpReportPillardates: [],
			visibleReportDays: [],
			// 血压测量统计meaStatistics
			nibpMeaStatistics: {
				netLoading:false,//网络请求中
				totalDays: 0, // 总天数或次数
				totalNum: 0, //测量总天数或次数
				totalStatus: 0, // 0未达标 1 达标(总测量)
				time6to8count: 0, //6到8点测量次数
				time17to19count: 0, //，测量次数
				time20to24count: 0, //20点到24点测量次数
				time6to8countStatus: 0, // 0为达标 1 达标
				time17to19countStatus: 0, // 0为达标 1 达标
				time20to24countStatus: 0, // 0为达标 1 达标
			},
			nibpStatus: {
				normalCount: 0, //正常血压次数
				normalHighCount: 0, //正常高值血压次数
				normalHighStatus: 0, // 0正常1异常
				highCount: 0, //高血压次数
				highStatus: 0, //0正常1异常
				oneLevelCount: 0, //一级高血压次数
				oneLevelStatus: 0, //0正常1异常
				twoLevelCount: 0, //二级高血压次数
				twoLevelStatus: 0, //0正常1异常
			},
			nibpInfoColor: {
				isHideNibpStatusAnd: true,
				totalStatusColor: '',
				time6to8countStatusColor: '',
				time17to19countStatusColor: '',
				time20to24countStatusColor: '',
				allNibpStatusColor: '',
				normalHighStatusColor: '',
				highStatusColor: '',
				oneLevelStatusColor: '',
				twoLevelStatusColor: '',

				allNibpStatisticsColor: '',
				sysStatusColor: '',
				diaStatusColor: '',
				maxMinSysStatusColor: '',
				maxMinDiaStatusColor: '',

				sysLoadDayTimeStatusColor: '', //0正常1异常  白天
				diaLoadDayTimeStatusColor: '', //0正常1异常 白天
				sysLoadNightStatusColor: '', //0正常1异常
				diaLoadNightStatusColor: '', //0正常1异常
				sysLoad24hStatusColor: '', //0正常1异常
				diaLoad24hStatusColor: '', //0正常1异常
				nightSysDecRateStatusColor: '',
				nightDiaDecRateStatusColor: '',
				avgDongMaiStatusColor: '',
				sysCvDayTimeStatusColor: '', //0正常1异常  白天
				diaCvDayTimeStatusColor: '', //0正常1异常 白天
				sysCvNightStatusColor: '', //0正常1异常
				diaCvNightStatusColor: '', //0正常1异常
				sysCv24hStatusColor: '', //0正常1异常
				diaCv24hStatusColor: '', //0正常1异常 
			},
			// 血压统计meaStatistics
			nibpStatistics: {
				avgSys: 0, //高压平均值
				sysRefer: "< 130", //高压参考值
				sysStatus: 0, //0正常1异常
				avgDia: 0, //低压平均值
				diaRefer: "< 85", //低压参考值
				diaStatus: 0, //0正常1异常
				maxSys: 0, //高压最大值
				maxDia: 0, //低压最大值
				minSys: 0, //高压最小值
				minDia: 0, //低压最小值
				maxMinSysStatus: 0, //0正常1异常	
				maxMinDiaStatus: 0, //0正常1异常			

				sysLoadDayTime: 0, //白天高压负荷,//
				sysLoadDayTimeStatus: 0, //0正常1异常  白天
				diaLoadDayTime: 0, //低压负荷 白天，
				diaLoadDayTimeStatus: 0, //0正常1异常 白天
				sysLoadNight: 0, //高压负荷 夜间,//
				sysLoadNightStatus: 0, //0正常1异常
				diaLoadNight: 0, //低压负荷 夜间，
				diaLoadNightStatus: 0, //0正常1异常
				sysLoad24h: 0, //高压负荷,//
				sysLoad24hStatus: 0, //0正常1异常
				diaLoad24h: 0, //低压负荷，
				diaLoad24hStatus: 0, //0正常1异常
				loadRefer: 0, //负荷参考值, //

				nightSysDecRate: 0, // 夜间高压下降率
				nightSysDecRateStatus: 0, //0正常1异常
				nightDiaDecRate: 0, //夜间低压下降率
				nightDiaDecRateStatus: 0, //0正常1异常
				decRateRefer: ">=10% , <=20%", // <=20%，下降率参考值
				avgDongMai: 0, //平均动脉压
				avgDongMaiStatus: 0, //0正常1异常

				//变异系数
				coefficient24: {
					sys24: "0", //高压变异系数
					sys24OfDiff: "0", //标准差
					dia24: "0", //低压变异系数
					dia24OfDiff: "0", //标准差
				},
				coefficientDaytime: {
					sys24: "0", //高压变异系数
					sys24OfDiff: "0", //标准差
					dia24: "0", //低压变异系数
					dia24OfDiff: "0", //标准差
				},
				coefficientNight: {
					sys24: "0", //高压变异系数
					sys24OfDiff: "0", //标准差
					dia24: "0", //低压变异系数
					dia24OfDiff: "0", //标准差
				},
			},
			// 步数统计
			statistics: {
				stepsAvg: 0,
				stepsSum: 0
			},
			// 血氧白分比
			BOPercentage: {
				abnormal: 0,
				all: 100,
				normal: 0,
			},
			// 血氧白分比
			BOCSPercentage: {
				abnormal: 0,
				all: 100,
				normal: 0,
			},	
			pressType: 'ylzs', // ylzs 压力
			listJson: {
				'ylzs': [{
					key: '压力指数',
					color: '#55fa99',
					explain: '良好',
					limits: '0-25',
					toggleNum: 1
				},
				{
					key: '压力指数',
					color: '#ffe372',
					explain: '尚好',
					limits: '26-50',
					toggleNum: 1
				},
				{
					key: '压力指数',
					color: '#ffa777',
					explain: '中等',
					limits: '51-75',
					toggleNum: 1
				},
				{
					key: '压力指数',
					color: '#ff6565',
					explain: '较差',
					limits: '76-100',
					toggleNum: 1
				},
				],
				'tired': [{
					key: '疲劳度',
					color: '#55fa99',
					explain: '轻松',
					limits: '0-33',
					toggleNum: 2
				},
				{
					key: '疲劳度',
					color: '#ffe372',
					explain: '较累',
					limits: '34-66',
					toggleNum: 3
				},
				{
					key: '疲劳度',
					color: '#ff6565',
					explain: '疲劳',
					limits: '67-100',
					toggleNum: 4
				},
				],
				'jsyl': [{
					key: '精神压力',
					color: '#55fa99',
					explain: '低',
					limits: '0-25',
					toggleNum: 3
				},
				{
					key: '精神压力',
					color: '#ffe372',
					explain: '中',
					limits: '26-50',
					toggleNum: 3
				},
				{
					key: '精神压力',
					color: '#ffa777',
					explain: '高',
					limits: '51-75',
					toggleNum: 3
				},
				{
					key: '精神压力',
					color: '#ff6565',
					explain: '很高',
					limits: '76-100',
					toggleNum: 3
				},
				],
				'kynl': [{
					key: '抗压能力',
					color: '#ff6565',
					explain: '低',
					limits: '0-25',
					toggleNum: 4
				},
				{
					key: '抗压能力',
					color: '#ffa777',
					explain: '中',
					limits: '26-50',
					toggleNum: 4
				},
				{
					key: '抗压能力',
					color: '#ffe372',
					explain: '高',
					limits: '51-75',
					toggleNum: 4
				},
				{
					key: '抗压能力',
					color: '#55fa99',
					explain: '很高',
					limits: '76-100',
					toggleNum: 4
				},
				],
			},

		};
	},
	computed: {
		...mapState([
			"xAxisType", // x轴标量类型，绘图中使用
			"switchTime", // 转换时间，请求接口时使用
		]),

		// 步数canvas绘图，根据最大值变化
		scale() {
			let max = 1000;
			let scale = 1;


			for (let i = 0; i < this.SNDotsOld.length; i++) {
				if (this.returnTime.type == '日') {
					max = Math.max(max, this.SNDotsOld[i]['steps'] | 0);
				} else {
					max = Math.max(max, this.SNDotsOld[i]['avgsteps'] | 0, this.SNDotsOld[i]['maxsteps'] | 0);
				}
			}
			scale = Math.ceil(max / 1000);

			return scale;
		},
	},
	filters: {
		time,
		// 返回日、周、月、年对应的日期
		getTypeTime,
		getTypeTimeLanguage,
		// 数字格式化：去除非数字、添加逗号、设置小数点（默认无小数点）  (s, n=0)
		fmoney,
		// x轴换算(x,startTime=0,endTime=300,width=300) xAxisCompute的反向逻辑
		xAxisCompute2,
		// y轴换算(y,min=0,max=300,height=300) xAxisCompute的反向逻辑
		yAxisCompute2,

		getCalorie,
		getDistance,
		getEggNum,
		getCircleNum,
	},
	watch: {

	},
	methods: {
		jsonToParams,
		time,
		// 获取时间段  (type,newTime,callback)  类型：日、周、月、年    标记时间戳：一般为现在时间    回调函数    依赖js-time.js插件
		getLimits,
		// 将字符串转变成成时间(str,type)   时间字符串   改写的字符串类型
		stringToTimestamp,
		// y轴换算(y,min=0,max=300,height=300)  max:y:min 对应 height:newY:0
		yAxisCompute,
		xAxisComputeSleepReport,
		xAxisComputeNibpReport,
		xAxisComputeSportHrReport,
		xAxisComputeSportHrTimemapReport,
		xAxisComputeSportHrHexReport,
		// x轴换算（将时间戳转换成x轴数据）(timestamp=new Date().getTime(),type="日",width=300,callback)    类型：日、周、月、年    标记时间戳：一般为现在时间    x轴最大宽度    回调函数
		xAxisCompute,
		remToPx,
		arrAv,
		toggleCanvas(pressType) {
			this.pressType = pressType;
			this.resetCanvas('canvasOnoff');
			this.getTrend('hrv_num');
		},
		getYAxiosArr,


		// 用于自定义事件sendTime，返回时间数据时触发-----------------------------------------------------------------------------------------------------------
		// 获取趋势点集   SN：步数   血压 nibp；心率 hr； 血氧 ：spo2； 压力：hrv_num   体温：bodytemp  sleep
		getTrend(category = 'SN') {
			if (!(category == 'SN' || category == 'nibp' || category == 'spo2' || category == 'hr' || category ==
				'hrv_num' || category == 'bodytemp' || category == 'sleep')) {
				alert("趋势类型参数错误");
			} else if (category == 'sleep') {
				getSleepReport({
					pid: this.$route.query.pid, // 网址传参--------------------------
					typeFlag: this.returnTime.type == '日' ? 1 : (this.returnTime.type == '周' ? 2 : (this.returnTime.type == '月' ? 3 : 4)),
					startCtime: this.returnTime.startTime,
					endCtime: this.returnTime.endTime,
				}).then(res => {
					console.log(category + "-res.data.data:------- ", res.data.data);
					let dots = res.data.data;

					if (!dots) { // 没有数据的情况
						console.log("请求结果异常---------------");
						return false;
					} else if (dots.length > 0) {
						if (this.returnTime.type == '日') {
							if (!this.$refs.SleepBrokenLine) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							}
							this.SleepReport.sleepTimeSecond = dots[0].ts;
							this.SleepReport.deepSleepSecond = dots[0].srts;
							this.SleepReport.lightSleepSecond = dots[0].qrts;
							this.SleepReport.remSleepSecond = dots[0].ydts;

							this.SleepReport.sleepWakeNum = dots[0].soberNumber;
							if(dots.length%3==0){
								let tmpTime=(dots[0].ets-dots[0].sts)/2+dots[0].sts;
								this.SleepReport.xLimit = [time(dots[0].sts).format("DD日 HH:mm"),time(tmpTime).format("DD日 HH:mm"),time(dots.slice(-1)[0].ets).format("DD日 HH:mm")];
							}else{
								this.SleepReport.xLimit = [time(dots[0].sts).format("DD日 HH:mm"),time(dots.slice(-1)[0].ets).format("DD日 HH:mm")];
							}
							
							//console.log("睡眠日-------------", this.SleepReport);
							//console.log("width:", this.$refs.SleepBrokenLine.width)
							dots = dots.map((currentValue) => {
								return {
									x: this.xAxisComputeSleepReport(currentValue.sdSts, currentValue.sts, currentValue.ets, this.$refs
										.SleepBrokenLine.width),
									x1: this.xAxisComputeSleepReport(currentValue.sdEts, currentValue.sts, currentValue.ets, this.$refs
										.SleepBrokenLine.width),
									y: this.yAxisCompute(currentValue.sleepType, 0, 5, this.$refs.SleepBrokenLine.height),
									data: currentValue
								}
							});
							//console.log('睡眠日 SleepDots  dots', dots)
						} else {
							if (!this.$refs.SleepPillar) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							}
							//console.log("width:", this.$refs.SleepPillar.width)
							let maxTimeScondSum = 0;
							let sleepTimeSecondSum = 0;
							let deepTimeSecondSum = 0;
							let lightTimeSecondSum = 0;
							let remSleepTimeSecondSum = 0;
							let sleepWakeNumSum = 0;
							let sleepBeginTimeSum = 0;//24小时制，大于12点，小于或者等于23点   则为负数   按分钟计算
							let sleepEndTimeSum = 0;//24小时制，大于12点，小于或者等于23点   则为负数    按分钟计算
							for (let currentValue in dots) {
								sleepTimeSecondSum = sleepTimeSecondSum + dots[currentValue].ts;
								deepTimeSecondSum = deepTimeSecondSum + dots[currentValue].srts;
								lightTimeSecondSum = lightTimeSecondSum + dots[currentValue].qrts;
								remSleepTimeSecondSum = remSleepTimeSecondSum + dots[currentValue].ydts;
								sleepWakeNumSum = sleepWakeNumSum + dots[currentValue].soberNumber;
								if (time(dots[currentValue].sts).format("HH") <= 23 && time(dots[currentValue].sts).format("HH") > 12) {
									sleepBeginTimeSum = sleepBeginTimeSum + parseInt(time(dots[currentValue].sts).format("HH") - 24) * 60 + parseInt(time(dots[currentValue].sts).format("mm"));
								} else {
									sleepBeginTimeSum = sleepBeginTimeSum + parseInt(time(dots[currentValue].sts).format("HH")) * 60 + parseInt(time(dots[currentValue].sts).format("mm"));
								}
								// console.log('hour=',time(dots[currentValue].sts).format("HH"))
								// console.log('min=',time(dots[currentValue].sts).format("mm"))
								// console.log('sleepBeginTimeSum=',sleepBeginTimeSum)
								if (time(dots[currentValue].ets).format("HH") <= 23 && time(dots[currentValue].ets).format("HH") > 12) {
									sleepEndTimeSum = sleepEndTimeSum + parseInt(time(dots[currentValue].ets).format("HH") - 24) * 60 + parseInt(time(dots[currentValue].ets).format("mm"));
								} else {
									sleepEndTimeSum = sleepEndTimeSum + parseInt(time(dots[currentValue].ets).format("HH")) * 60 + parseInt(time(dots[currentValue].ets).format("mm"));
								}
								if (dots[currentValue].ts > maxTimeScondSum) {
									maxTimeScondSum = dots[currentValue].ts;
								}
							}
							// console.log('maxTimeScondSum=',maxTimeScondSum,'maxTimeScondSum/3600='+maxTimeScondSum/3600,'(maxTimeScondSum/3600)+1=',(maxTimeScondSum/3600)+1);
							if (0 == maxTimeScondSum) {
								this.SleepReport.yLimit = [0, 2, 4, 6, 8, 10, 12];
							} else {
								if ((maxTimeScondSum / 3600) + 1 <= 4) {
									this.SleepReport.yLimit = [0, 2, 4];
								} else if ((maxTimeScondSum / 3600) + 1 <= 6) {
									this.SleepReport.yLimit = [0, 2, 4, 6];
								} else if ((maxTimeScondSum / 3600) + 1 <= 8) {
									this.SleepReport.yLimit = [0, 2, 4, 6, 8];
								} else if ((maxTimeScondSum / 3600) + 1 <= 10) {
									this.SleepReport.yLimit = [0, 2, 4, 6, 8, 10];
								} else if ((maxTimeScondSum / 3600) + 1 <= 12) {
									this.SleepReport.yLimit = [0, 2, 4, 6, 8, 10];
								} else {
									this.SleepReport.yLimit = [0, 3, 6, 9, 15];
								}
							}
							// console.log('this.SleepReport.yLimit=',this.SleepReport.yLimit)
							this.SleepReport.sleepTimeSecond = sleepTimeSecondSum / dots.length;
							this.SleepReport.deepSleepSecond = deepTimeSecondSum / dots.length;
							this.SleepReport.lightSleepSecond = lightTimeSecondSum / dots.length;
							this.SleepReport.remSleepSecond = remSleepTimeSecondSum / dots.length;
							this.SleepReport.sleepWakeNum = sleepWakeNumSum / dots.length;
							let hourBegin = 0;
							let minBegin = 0;
							let hourEnd = 0;
							let minEnd = 0;
							if (sleepBeginTimeSum < 0) {
								hourBegin = (24 + parseInt(((sleepBeginTimeSum / dots.length) / 60).toFixed(0)));
								minBegin = (60 + parseInt(((sleepBeginTimeSum / dots.length) % 60)));
							} else {
								hourBegin = ((parseInt((sleepBeginTimeSum / dots.length) / 60).toFixed(0)));
								minBegin = ((parseInt((sleepBeginTimeSum / dots.length) % 60)));
							}
							this.SleepReport.sleepBeginTime = (hourBegin < 10 ? ('0' + hourBegin) : hourBegin) + ':' + (minBegin < 10 ? ('0' + minBegin) : minBegin);
							if (sleepEndTimeSum < 0) {
								hourEnd = (24 + parseInt(((sleepEndTimeSum / dots.length) / 60).toFixed(0)));
								minEnd = (60 + parseInt(((sleepEndTimeSum / dots.length) % 60)));
							} else {
								hourEnd = ((parseInt((sleepEndTimeSum / dots.length) / 60).toFixed(0)));
								minEnd = ((parseInt((sleepEndTimeSum / dots.length) % 60)));
							}
							this.SleepReport.sleepEndTime = (hourEnd < 10 ? ('0' + hourEnd) : hourEnd) + ':' + (minEnd < 10 ? ('0' + minEnd) : minEnd);
							//console.log('this.SleepReport=', this.SleepReport)
							dots = dots.map((currentValue) => {
								return {
									x: this.xAxisCompute(currentValue.sleepDate, this.returnTime.type, this.$refs.SleepPillar.width),
									y: this.yAxisCompute(currentValue.srts / 60, 0, this.SleepReport.yLimit.slice(-1)[0] * 60, this.$refs.SleepPillar.height),
									y1: this.yAxisCompute((currentValue.srts + currentValue.qrts) / 60, 0, this.SleepReport.yLimit.slice(-1)[0] * 60, this.$refs.SleepPillar.height),
									y2: this.yAxisCompute((currentValue.srts + currentValue.qrts + currentValue.ydts) / 60, 0, this.SleepReport.yLimit.slice(-1)[0] * 60, this.$refs.SleepPillar.height),
									y3: this.yAxisCompute((currentValue.srts + currentValue.qrts + currentValue.ydts + 0) / 60, 0, this.SleepReport.yLimit.slice(-1)[0] * 60, this.$refs.SleepPillar.height),
									data: currentValue
								}
							});
						}
					}

					// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
					this.SleepDots = dots;
					//console.log('SleepDots', this.SleepDots)
					//// this.SNDotsOld = res.data.data;
					this.resetCanvas("SleepCanvasOnoff");
				});

			} else if (category == 'SN') {
				getTrend({
					pid: this.$route.query.pid, // 网址传参--------------------------
					type: this.returnTime.type == '日' ? 'day' : this.switchTime[this.returnTime.type],
					extend: 1, // 仅计步时使用，网址传参--------------------------
					sts: this.returnTime.startTime,
					ets: this.returnTime.endTime,
					date: this.$route.query.date || time(this.returnTime.startTime).format(
						"YYYY-MM-DD") // 仅计步时使用--------------------
				}).then(res => {
					console.log(category + "-res.data.data:------- ", res.data.data);
					let dots = res.data.data;
					this.dayStepSum = 0; // 初始化



					if (!dots) { // 没有数据的情况
						console.log("请求结果异常---------------");
						return false;
					} else if (!this.$refs.SNPillar) { // 没有组件时的情况
						console.log("没有对应组件-------------");
						return false;
					} else if (dots.length > 0) {


						if (this.returnTime.type == '日') {
							dots = dots.map((currentValue) => {
								// console.log("7");
								this.dayStepSum = this.dayStepSum + Math.round(currentValue.steps);
								// console.log("this.dayStepSum: ",this.dayStepSum);

								return {
									x: this.xAxisCompute(this.stringToTimestamp(currentValue
										.mtimeFormat, this.returnTime.type), this.returnTime
										.type, this.$refs.SNPillar.width),
									y: this.yAxisCompute(Math.round(currentValue.steps), this.$refs
										.SNPillar.yAxis[0], this.$refs.SNPillar.yAxis.slice(-1)[0],
										this.$refs.SNPillar.height),
								}
							});
						} else {
							dots = dots.map((currentValue) => {
								return {
									x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
										this.returnTime.type), this.returnTime.type, this.$refs
											.SNPillar.width),
									y: this.yAxisCompute(this.returnTime.type == '年' ? Math.round(
										currentValue.avgsteps) : Math.round(currentValue
											.maxsteps), this.$refs.SNPillar.yAxis[0], this.$refs
												.SNPillar.yAxis.slice(-1)[0], this.$refs.SNPillar.height),
								}
							});
						}
					}

					// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
					this.SNDots = dots;
					this.SNDotsOld = res.data.data;
					this.resetCanvas("SNCanvasOnoff");
				});

			} else if (category != 'SN') {
				getTrend({
					pid: this.$route.query.pid, // 网址传参--------------------------
					type: this.switchTime[this.returnTime.type],
					category, // 可以网址传参--------------------------
					sts: this.returnTime.startTime,
					ets: this.returnTime.endTime
				}).then(res => {
					console.log(category + "-res.data.data:------- ", res.data.data);
					let dots = res.data.data;


					if (!dots) { // 没有数据的情况
						console.log("请求结果异常---------------");
						return false;
					}


					if (category == 'nibp') {
						if (!this.$refs.BPPillar) { // 没有组件时的情况
							console.log("没有对应组件-------------");
							return false;
						} else if (dots.length > 0) {
							if (this.returnTime.type === '日') {
								dots = dots.map((currentValue, index, arr) => {
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.BPPillar.width),
										y: this.yAxisCompute(Math.round(currentValue.avgdia), this.$refs
											.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[
										0], this.$refs.BPPillar.height),
										y2: this.yAxisCompute(Math.round(currentValue.avgsys), this
											.$refs.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis
												.slice(-1)[0], this.$refs.BPPillar.height),
									}
								});
							} else {
								dots = dots.map((currentValue, index, arr) => {
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.BPPillar.width),
										y: this.yAxisCompute(Math.round(currentValue.mindia), this.$refs
											.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[
										0], this.$refs.BPPillar.height),
										y2: this.yAxisCompute(Math.round(currentValue.maxdia), this
											.$refs.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis
												.slice(-1)[0], this.$refs.BPPillar.height),
										y3: this.yAxisCompute(Math.round(currentValue.minsys), this
											.$refs.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis
												.slice(-1)[0], this.$refs.BPPillar.height),
										y4: this.yAxisCompute(Math.round(currentValue.maxsys), this
											.$refs.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis
												.slice(-1)[0], this.$refs.BPPillar.height),
									}
								});
							}
						}

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						this.BPDots = dots;
						// console.log("this.BPDots心率-------------: ",this.BPDots);
						this.resetCanvas("BPCanvasOnoff");
					} else if (category == 'spo2') {
						if (!this.$refs.BOPillar) { // 没有组件时的情况
							console.log("没有对应组件-------------");
							return false;
						} else if (dots.length > 0) {
							if (this.returnTime.type === '日') {
								dots = dots.map((currentValue, index, arr) => {
									let y = this.yAxisCompute(Math.round(currentValue.avgspo2), this
										.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
											1)[0], this.$refs.BOPillar.height);
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.BOPillar.width),
										y: y > this.canvasHeight ? this.canvasHeight : y,
									}
								});
							} else {
								dots = dots.map((currentValue, index, arr) => {
									let y = this.yAxisCompute(Math.round(currentValue.minspo2), this
										.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
											1)[0], this.$refs.BOPillar.height);
									let y2 = this.yAxisCompute(Math.round(currentValue.maxspo2), this
										.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
											1)[0], this.$refs.BOPillar.height);
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.BOPillar.width),
										y: y,
										y2: y2 > this.canvasHeight ? this.canvasHeight : y2,
									}
								});
							}
						}

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						this.BODots = dots;
						this.BODotsOld = res.data.data;

						this.resetCanvas("BOCanvasOnoff");
					} else if (category == 'hr') {
						if (!this.$refs.HRBrokenLine) { // 没有组件时的情况
							console.log("没有对应组件-------------");
							return false;
						} else if (dots.length > 0) {
							if (this.returnTime.type === '日') {
								dots = dots.map((currentValue, index, arr) => {
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.HRBrokenLine.width),
										y: this.yAxisCompute(Math.round(currentValue.avghr), this.$refs
											.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
												.slice(-1)[0], this.$refs.HRBrokenLine.height),
									}
								});
							} else {
								dots = dots.map((currentValue, index, arr) => {
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.HRBrokenLine.width),
										y: this.yAxisCompute(Math.round(currentValue.minhr), this.$refs
											.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
												.slice(-1)[0], this.$refs.HRBrokenLine.height),
										y2: this.yAxisCompute(Math.round(currentValue.maxhr), this.$refs
											.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
												.slice(-1)[0], this.$refs.HRBrokenLine.height),
									}
								});
							}
						}

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						this.HRDots = dots;
						this.HRDotsOld = res.data.data;
						// console.log("this.HRDots: ",this.HRDots);
						this.resetCanvas("HRCanvasOnoff");
					} else if (category == 'hrv_num') {
						if (!this.$refs.PPillar) { // 没有组件时的情况
							console.log("没有对应组件-------------");
							return false;
						} else if (dots.length > 0) {
							// if(  this.returnTime.type==='日'  ){
							/* if(  this.pressType  ){
								dots = dots.map((currentValue,index,arr)=>{
									let y = this.yAxisCompute(Math.round(currentValue[this.pressType]), this.$refs.PPillar.yAxis[0], this.$refs.PPillar.yAxis.slice(-1)[0], this.$refs.PPillar.height);
									return {
										x:this.xAxisCompute(  this.stringToTimestamp(currentValue.period, this.returnTime.type), this.returnTime.type, this.$refs.PPillar.width),
										y:y>this.canvasHeight ? this.canvasHeight : y,
									}
								});
							} */
							if (this.returnTime.type === '日') {
								dots = dots.map((currentValue, index, arr) => {
									let y = this.yAxisCompute(Math.round(currentValue[this.pressType]),
										this.$refs.PPillar.yAxis[0], this.$refs.PPillar.yAxis.slice(
											-1)[0], this.$refs.PPillar.height);
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.PPillar.width),
										y: y > this.canvasHeight ? this.canvasHeight : y,
									}
								});
							} else {
								dots = dots.map((currentValue, index, arr) => {
									let y = this.yAxisCompute(Math.round(currentValue['min' + this
										.pressType]), this.$refs.PPillar.yAxis[0], this.$refs
											.PPillar.yAxis.slice(-1)[0], this.$refs.PPillar.height);
									let y2 = this.yAxisCompute(Math.round(currentValue['max' + this
										.pressType]), this.$refs.PPillar.yAxis[0], this.$refs
											.PPillar.yAxis.slice(-1)[0], this.$refs.PPillar.height);
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.PPillar.width),
										y: y,
										y2: y2 > this.canvasHeight ? this.canvasHeight : y2,
									}
								});
							}
						}

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						this.PDots = dots;
						console.log("this.PDots: ", this.PDots);
						this.PDotsOld = res.data.data;

						this.resetCanvas("PCanvasOnoff");
					} else if (category == 'bodytemp') {
						if (!this.$refs.TBrokenLine) { // 没有组件时的情况
							console.log("没有对应组件-------------");
							return false;
						} else if (dots.length > 0) {
							if (this.returnTime.type === '日') {
								dots = dots.map((currentValue, index, arr) => {
									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.TBrokenLine.width),
										y: this.yAxisCompute((currentValue.avgtemp / 100).toFixed(1),
											this.$refs.TBrokenLine.yAxis[0], this.$refs.TBrokenLine
												.yAxis.slice(-1)[0], this.$refs.TBrokenLine.height),
									}
								});
							} else {
								dots = dots.map((currentValue, index, arr) => {

									return {
										x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
											this.returnTime.type), this.returnTime.type, this
												.$refs.TBrokenLine.width),
										y: this.yAxisCompute((currentValue.mintemp / 100).toFixed(1),
											this.$refs.TBrokenLine.yAxis[0], this.$refs.TBrokenLine
												.yAxis.slice(-1)[0], this.$refs.TBrokenLine.height),
										y2: this.yAxisCompute((currentValue.maxtemp / 100).toFixed(1),
											this.$refs.TBrokenLine.yAxis[0], this.$refs.TBrokenLine
												.yAxis.slice(-1)[0], this.$refs.TBrokenLine.height),
									}
								});
							}


						}

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						this.TDots = dots;
						this.TDotsOld = res.data.data;
						console.log("this.TDots: ", this.TDots);
						this.resetCanvas("TCanvasOnoff");

					}


				});

			}

		},
		// 用于自定义事件sendTime，返回时间数据时触发-----------------------------------------------------------------------------------------------------------
		// 获取趋势点集   SN：步数   血压 nibp；心率 hr； 血氧 ：spo2； 压力：hrv_num   体温：bodytemp  sleep
		getTrendType(category = 'hr',type) {
			if (!(category == 'spo2' || category == 'hr')) {
				alert("趋势类型参数错误");
			} else {
				getTrend({
					pid: this.$route.query.pid, // 网址传参--------------------------
					type: this.switchTime[this.returnTime.type],
					category, // 可以网址传参--------------------------
					sts: this.returnTime.startTime,
					ets: this.returnTime.endTime,
					measureWay:type
				}).then(res => {
					console.log(category + "-res.data.data:------- ", res.data.data);
					let dots = res.data.data;


					if (!dots) { // 没有数据的情况
						console.log("请求结果异常---------------");
						return false;
					}

					if (category == 'spo2') {
						

						// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
						if(type==1){
							if (!this.$refs.BOCSPillar) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							} else if (dots.length > 0) {
								if (this.returnTime.type === '日') {
									dots = dots.map((currentValue, index, arr) => {
										let y = this.yAxisCompute(Math.round(currentValue.avgspo2), this
											.$refs.BOCSPillar.yAxis[0], this.$refs.BOCSPillar.yAxis.slice(-
												1)[0], this.$refs.BOCSPillar.height);
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.BOCSPillar.width),
											y: y > this.canvasHeight ? this.canvasHeight : y,
										}
									});
								} else {
									dots = dots.map((currentValue, index, arr) => {
										let y = this.yAxisCompute(Math.round(currentValue.minspo2), this
											.$refs.BOCSPillar.yAxis[0], this.$refs.BOCSPillar.yAxis.slice(-
												1)[0], this.$refs.BOCSPillar.height);
										let y2 = this.yAxisCompute(Math.round(currentValue.maxspo2), this
											.$refs.BOCSPillar.yAxis[0], this.$refs.BOCSPillar.yAxis.slice(-
												1)[0], this.$refs.BOCSPillar.height);
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.BOCSPillar.width),
											y: y,
											y2: y2 > this.canvasHeight ? this.canvasHeight : y2,
										}
									});
								}
							}
							this.BOCSDots = dots;
							this.BOCSDotsOld = res.data.data;
							this.getCSBOLimits();
							this.resetCanvas("BOCSCanvasOnoff");
						}else{
							if (!this.$refs.BOPillar) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							} else if (dots.length > 0) {
								if (this.returnTime.type === '日') {
									dots = dots.map((currentValue, index, arr) => {
										let y = this.yAxisCompute(Math.round(currentValue.avgspo2), this
											.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
												1)[0], this.$refs.BOPillar.height);
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.BOPillar.width),
											y: y > this.canvasHeight ? this.canvasHeight : y,
										}
									});
								} else {
									dots = dots.map((currentValue, index, arr) => {
										let y = this.yAxisCompute(Math.round(currentValue.minspo2), this
											.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
												1)[0], this.$refs.BOPillar.height);
										let y2 = this.yAxisCompute(Math.round(currentValue.maxspo2), this
											.$refs.BOPillar.yAxis[0], this.$refs.BOPillar.yAxis.slice(-
												1)[0], this.$refs.BOPillar.height);
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.BOPillar.width),
											y: y,
											y2: y2 > this.canvasHeight ? this.canvasHeight : y2,
										}
									});
								}
							}
							this.BODots = dots;
							this.BODotsOld = res.data.data;
							this.getBOLimits();
							this.resetCanvas("BOCanvasOnoff");
						}
					} else if (category == 'hr') {
						if(type==1){
							if (!this.$refs.HRCSBrokenLine) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							} else if (dots.length > 0) {
								if (this.returnTime.type === '日') {
									dots = dots.map((currentValue, index, arr) => {
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.HRCSBrokenLine.width),
											y: this.yAxisCompute(Math.round(currentValue.avghr), this.$refs
												.HRCSBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRCSBrokenLine.height),
										}
									});
								} else {
									dots = dots.map((currentValue, index, arr) => {
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.HRCSBrokenLine.width),
											y: this.yAxisCompute(Math.round(currentValue.minhr), this.$refs
												.HRCSBrokenLine.yAxis[0], this.$refs.HRCSBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRCSBrokenLine.height),
											y2: this.yAxisCompute(Math.round(currentValue.maxhr), this.$refs
												.HRCSBrokenLine.yAxis[0], this.$refs.HRCSBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRCSBrokenLine.height),
										}
									});
								}
							}
							this.HRCSDots = dots;
							this.HRCSDotsOld = res.data.data;
							this.resetCanvas("HRCSCanvasOnoff");
						}else{
							if (!this.$refs.HRBrokenLine) { // 没有组件时的情况
								console.log("没有对应组件-------------");
								return false;
							} else if (dots.length > 0) {
								if (this.returnTime.type === '日') {
									dots = dots.map((currentValue, index, arr) => {
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.HRBrokenLine.width),
											y: this.yAxisCompute(Math.round(currentValue.avghr), this.$refs
												.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRBrokenLine.height),
										}
									});
								} else {
									dots = dots.map((currentValue, index, arr) => {
										return {
											x: this.xAxisCompute(this.stringToTimestamp(currentValue.period,
												this.returnTime.type), this.returnTime.type, this
													.$refs.HRBrokenLine.width),
											y: this.yAxisCompute(Math.round(currentValue.minhr), this.$refs
												.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRBrokenLine.height),
											y2: this.yAxisCompute(Math.round(currentValue.maxhr), this.$refs
												.HRBrokenLine.yAxis[0], this.$refs.HRBrokenLine.yAxis
													.slice(-1)[0], this.$refs.HRBrokenLine.height),
										}
									});
								}
							}
							// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
							this.HRDots = dots;
							this.HRDotsOld = res.data.data;
							this.resetCanvas("HRCanvasOnoff");
						}
					} 
				});

			}

		},
		getBOLimits(){
			let arr = [];

			for(  let i=0;i<this.BODotsOld.length;i++  ){
				let item = this.BODotsOld[i];
				if(  item["avgspo2"]  )  arr.push(item["avgspo2"]);
				if( item["maxspo2"] )  arr.push(item["maxspo2"]);
				if( item["minspo2"] )  arr.push(item["minspo2"]);
			}

			arr = arr.sort(function ( a, b ) {  return a - b;  });
			// console.log("arr: ",arr);
			this.BOLimits.minBO = arr[0];
			this.BOLimits.maxBO = arr.slice(-1)[0];

			if(  this.BOLimits.minBO<0  )    this.BOLimits.minBO =0;
			if(  this.BOLimits.maxBO>100 )    this.BOLimits.maxBO = 100;
		},
		getCSBOLimits(){
			let arr = [];

			for(  let i=0;i<this.BOCSDotsOld.length;i++  ){
				let item = this.BOCSDotsOld[i];
				if(  item["avgspo2"]  )  arr.push(item["avgspo2"]);
				if( item["maxspo2"] )  arr.push(item["maxspo2"]);
				if( item["minspo2"] )  arr.push(item["minspo2"]);
			}

			arr = arr.sort(function ( a, b ) {  return a - b;  });
			// console.log("arr: ",arr);
			this.BOCSLimits.minBO = arr[0];
			this.BOCSLimits.maxBO = arr.slice(-1)[0];

			if(  this.BOCSLimits.minBO<0  )    this.BOCSLimits.minBO =0;
			if(  this.BOCSLimits.maxBO>100 )    this.BOCSLimits.maxBO = 100;
		},
		getSportDetailList(sportId,callback) {
			getSportDetailListData({
				sportsId: sportId,
			}).then(res => {
				console.log("getSportDetailListData-res.data.data:------- ", res.data.data);
				let locaitonDots=[];

				res.data.data.forEach((item, i) => {
					if(item&&(item.latitude!=0||item.longitude!=0)){
						locaitonDots.push(item);
					}
				})
				this.sportReportLocationDots=locaitonDots;
				if(this.sportReportLocationDots&&this.sportReportLocationDots.length>0){
					if( callback ){  callback();  }
				}
			});
	
		},
		getSportDetail(sportId,callback) {
			getSportDetailData({
				sportsId: sportId,
			}).then(res => {
				console.log("getSportDetailData-res.data.data:------- ", res.data.data);
				this.sportReportDetailData= res.data.data;
				// console.log("getSportDetailData-res.data.data:------- ", this.sportReportDetailData);
				this.sportReportDetailData.ets=parseInt(this.sportReportDetailData.sts+this.sportReportDetailData.ts*1000);
				// console.log("getSportDetailData-res.data.data ets:------- ", this.sportReportDetailData.ets);


				//根据时间段去拆分出按分钟的x轴
				let xSpace=parseInt(this.sportReportDetailData.ts/360);
				if(xSpace==0){
					xSpace=1;
				}
				this.sportReportDetailData.xzhou=[xSpace,2*xSpace,3*xSpace,4*xSpace,5*xSpace,6*xSpace];
				console.log("getSportDetailData-res.data.data xzhou:------- ", this.sportReportDetailData.xzhou);

				//根据字符串计算心率图
				if(this.sportReportDetailData.hrChart){
					if (this.$refs.SportHrBrokenLine) { // 没有组件时的情况
						let tempHrChartdots=[];
						if(this.sportReportDetailData.hrChart.slice(0,2)=='0x'){
							let tmpHrChartStr=this.sportReportDetailData.hrChart.slice(2,this.sportReportDetailData.hrChart.length);
							
							for(let i=0;i<tmpHrChartStr.length/12;i++){
								let tmpValue={'hr':parseInt("0x"+tmpHrChartStr.slice(0+12*i,4+i*12)),
									'time':parseInt("0x"+tmpHrChartStr.slice(4+i*12,12+i*12))};
									tempHrChartdots.push(tmpValue);
							}
							tempHrChartdots= tempHrChartdots.map((currentValue, index, arr) => {
								return {
									x: this.xAxisComputeSportHrHexReport(currentValue.time, this.sportReportDetailData.sts, this.sportReportDetailData.ets, this.$refs.SportHrBrokenLine.width),
									y: this.yAxisCompute(Math.round(currentValue.hr), this.$refs.SportHrBrokenLine.yAxis[0], this.$refs.SportHrBrokenLine.yAxis.slice(-1)[0],
										this.$refs.SportHrBrokenLine.height)
										,data:currentValue
								}
							});
						}else{
							tempHrChartdots=JSON.parse(this.sportReportDetailData.hrChart)
							tempHrChartdots= tempHrChartdots.map((currentValue, index, arr) => {
								let tmpIndex=index;
								if(index==0){
									tmpIndex=1;
								}
							
								let currentTime=tmpIndex*currentValue.period;
								if(currentValue.period>1600000000000){
									currentTime=currentValue.period;
									return {
										x: this.xAxisComputeSportHrTimemapReport(currentTime, this.sportReportDetailData.sts, this.sportReportDetailData.ets, this.$refs.SportHrBrokenLine.width),
										y: this.yAxisCompute(Math.round(currentValue.hr), this.$refs.SportHrBrokenLine.yAxis[0], this.$refs.SportHrBrokenLine.yAxis.slice(-1)[0],
											this.$refs.SportHrBrokenLine.height)
											,data:currentValue
									}
								}else{
									return {
										x: this.xAxisComputeSportHrReport(currentTime, this.sportReportDetailData.sts, this.sportReportDetailData.ets, this.$refs.SportHrBrokenLine.width),
										y: this.yAxisCompute(Math.round(currentValue.hr), this.$refs.SportHrBrokenLine.yAxis[0], this.$refs.SportHrBrokenLine.yAxis.slice(-1)[0],
											this.$refs.SportHrBrokenLine.height)
											,data:currentValue
									}
								}
							});
						}
						this.sportReportDetailData.hrChartDots=tempHrChartdots;
					   console.log("getSportDetailData-res.data.data this.sportReportDetailData.hrChartDots:------- ",this.sportReportDetailData.hrChartDots);
					}else{
						console.log("没有对应组件-------------");
					}
					this.resetCanvas("HRSportCanvasOnoff");
				}
				if(this.sportReportDetailData.hrPieChart){
					this.sportReportDetailData.hrPieChart=JSON.parse(this.sportReportDetailData.hrPieChart)
					console.log("getSportDetailData-res.data.data  hrpie:------- ",this.sportReportDetailData.hrPieChart);
				}
				if(this.sportReportDetailData.kmChart){
					this.sportReportDetailData.kmChart=JSON.parse(this.sportReportDetailData.kmChart)
				 	console.log("getSportDetailData-res.data.data  kmChart:------- ",this.sportReportDetailData.kmChart);
				}

				//根据字符串计算步频
				if(this.sportReportDetailData.cadenceChart){
					let tempCadenceChartDots= JSON.parse(this.sportReportDetailData.cadenceChart)
					//根据时间段去拆分出步频的y轴
					let yCadenceSpace=parseInt((this.sportReportDetailData.maxCadence+20)/5);
					if(yCadenceSpace==0){
						yCadenceSpace=1;
					}
					this.sportReportDetailData.yCadenceZhou=[0,yCadenceSpace,2*yCadenceSpace,3*yCadenceSpace,4*yCadenceSpace,5*yCadenceSpace,6*yCadenceSpace];
					console.log("getSportDetailData-res.data.data yCadenceZhou:------- ", this.sportReportDetailData.yCadenceZhou);
					if (this.$refs.sportStepBrokenLine) { // 没有组件时的情况
						tempCadenceChartDots= tempCadenceChartDots.map((currentValue, index, arr) => {
						   return {
							   x: this.xAxisComputeNibpReport(currentValue.period, this.sportReportDetailData.sts, this.sportReportDetailData.ets, this.$refs.sportStepBrokenLine.width),
							   y: this.yAxisCompute(Math.round(currentValue.cadence), 0,parseInt(this.sportReportDetailData.maxCadence+20),
								   this.$refs.sportStepBrokenLine.height)
							    ,data:currentValue
						   }
					   });
					   this.sportReportDetailData.cadenceChartDots=tempCadenceChartDots;
					   console.log("getSportDetailData-res.data.data this.sportReportDetailData.cadenceChartDots:------- ",this.sportReportDetailData.cadenceChartDots);
					}else{
						console.log("没有对应组件-------------");
					}
					
					this.resetCanvas("StepSportCanvasOnoff");
				}

				//根据字符串计算配速
				if(this.sportReportDetailData.paceChart){
					let tempPaceChartDots=JSON.parse(this.sportReportDetailData.paceChart)
					// console.log("this.sportReportDetailData.maxPace=",this.sportReportDetailData.maxPace);
					//根据时间段去拆分出配速的y轴
					let minIndex=this.sportReportDetailData.maxPace.indexOf("'");
					if(-1==minIndex){
						minIndex=this.sportReportDetailData.maxPace.indexOf("’");
					}
					// console.log("minIndex=",minIndex);
					let maxSecondPace=parseInt(this.sportReportDetailData.maxPace.substring(0,minIndex))*60+parseInt(this.sportReportDetailData.maxPace.substring(minIndex+1,this.sportReportDetailData.maxPace.length-1));
					// console.log("maxSecondPace=",maxSecondPace);
					let yPaceSpace=parseInt((maxSecondPace+30)/5);
					if(yPaceSpace==0){
						yPaceSpace=1;
					}
					console.log("yPaceSpace=",yPaceSpace);
					this.sportReportDetailData.yPaceZhou=[
						'0\'0\"',
						getMinBySecondNoHourStr(yPaceSpace)+'\''+getSecondBySecondStr(yPaceSpace)+'\"',
						getMinBySecondNoHourStr(2*yPaceSpace)+'\''+getSecondBySecondStr(2*yPaceSpace)+'\"',
						getMinBySecondNoHourStr(3*yPaceSpace)+'\''+getSecondBySecondStr(3*yPaceSpace)+'\"',
						getMinBySecondNoHourStr(4*yPaceSpace)+'\''+getSecondBySecondStr(4*yPaceSpace)+'\"',
						getMinBySecondNoHourStr(5*yPaceSpace)+'\''+getSecondBySecondStr(5*yPaceSpace)+'\"',
					];
					console.log("this.sportReportDetailData.yPaceZhou=",this.sportReportDetailData.yPaceZhou);
					if (this.$refs.sportPaceBrokenLine) { // 没有组件时的情况
						tempPaceChartDots= tempPaceChartDots.map((currentValue, index, arr) => {
						   return {
							   x: this.xAxisComputeNibpReport(currentValue.period, this.sportReportDetailData.sts, this.sportReportDetailData.ets, this.$refs.sportPaceBrokenLine.width),
							   y: this.yAxisCompute(Math.round(currentValue.pace), this.$refs.sportPaceBrokenLine.yAxis[0], this.$refs.sportPaceBrokenLine.yAxis.slice(-1)[0],
								   this.$refs.sportPaceBrokenLine.height)
							    ,data:currentValue
						   }
					   });
					   this.sportReportDetailData.paceChartDots=tempPaceChartDots;
					   console.log("getSportDetailData-res.data.data this.sportReportDetailData.paceChartDots:------- ",this.sportReportDetailData.paceChartDots);
					}else{
						console.log("没有对应组件-------------");
					}
					
					this.resetCanvas("PaceSportCanvasOnoff");
				}
				this.getSportDetailList(sportId,callback);
			});
		},
		getSportList(offsetTemp) {
			getSportListData({
				pid: this.$route.query.pid, // 网址传参--------------------------
				limit: this.pageNum,
				offset: offsetTemp,
			}).then(res => {
				console.log("getSportListData-res.data.data:------- ", res.data.data);
				this.sportMonthListData.isLoading = false;
				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.sportMonthListData.isNoData = true;
					// this.sportMonthListData.MonthDataListJson = [];
				} else {
					this.sportMonthListData.isNoData = false;
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.sportMonthListData.MonthDataListJson = [];
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.sportMonthListData.lastTimeFormat) {
								this.sportMonthListData.lastTimeFormat = time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit');
								item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
								tempMonthList.push(item);
							} else {
								// console.log(this.sportMonthListData.lastTimeFormat + "==i==    " + (time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit')));
								if (this.sportMonthListData.lastTimeFormat != (time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit'))) {
									this.sportMonthListData.MonthDataListJson.push({
										'time': this.sportMonthListData.lastTimeFormat,
										'sportDatas': tempMonthList
									});
									this.sportMonthListData.lastTimeFormat = time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit');
									tempMonthList = [];
									item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
									tempMonthList.push(item);

								} else {
									item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
									tempMonthList.push(item);
								}
							}
							// console.log("forEach循环==i==    ", i, tempMonthList, this.sportMonthListData.MonthDataListJson);
							if (i == length - 1) {
								this.sportMonthListData.MonthDataListJson.push({
									'time': this.sportMonthListData.lastTimeFormat,
									'sportDatas': tempMonthList
								});
							}

						})
						this.sportMonthListData.isShowBottom = false;
						this.sportMonthListData.monthDataSize = length;

					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							// console.log(this.sportMonthListData.lastTimeFormat + "==1111i==    " + time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit'));
							if ('' == this.sportMonthListData.lastTimeFormat) {
								this.sportMonthListData.lastTimeFormat = time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit');
								item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
								tempMonthList.push(item);
							} else {
								// console.log(this.sportMonthListData.lastTimeFormat + "==i==    " + (time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit')));
								if (this.sportMonthListData.lastTimeFormat != (time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.sportMonthListData.MonthDataListJson.push({
											'time': this.sportMonthListData.lastTimeFormat,
											'sportDatas': tempMonthList
										});
									}
									this.sportMonthListData.lastTimeFormat = time(item.sts).format('YYYY') + this.$t('common.yearUnit') + time(item.sts).format('MM') + this.$t('common.monthUnit');
									tempMonthList = [];
									item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
									tempMonthList.push(item);

								} else {
									tempMonthList = this.sportMonthListData.MonthDataListJson[this
										.sportMonthListData.MonthDataListJson.length - 1].sportDatas;
									item.time = time(item.sts).format('MM') + this.$t('common.monthUnit') + time(item.sts).format('DD') + this.$t('common.dayUnit');
									tempMonthList.push(item);
									this.sportMonthListData.MonthDataListJson[this.sportMonthListData.MonthDataListJson.length - 1].sportDatas = tempMonthList;
									tempMonthList = [];
								}
							}
							if (i == length - 1) {
								if (tempMonthList && tempMonthList.length > 0) {
									this.sportMonthListData.MonthDataListJson.push({
										'time': this.sportMonthListData.lastTimeFormat,
										'sportDatas': tempMonthList
									});
								}
							}
							// console.log("forEach循环==i==    ", i, 'this.sportMonthListData.MonthDataListJson=', this.sportMonthListData.MonthDataListJson);
							// console.log("forEach循环==i==    ", i);
						})
						this.sportMonthListData.isShowBottom = false;
						this.sportMonthListData.monthDataSize = this.sportMonthListData.monthDataSize + length;
					}

					if (length < this.pageNum) {
						//console.log("==no more==length=    " + length, "<",this.pageNum,"   list  =", this.sportMonthListData.MonthDataListJson);
						this.sportMonthListData.isBottomNoMore = true;
						if(this.sportMonthListData.MonthDataListJson.length==0){
							this.sportMonthListData.isNoData = true;
						}
					}
				}
			});
		},
		getStepList(offsetTemp,ets) {
			getStepListData({
				pid: this.$route.query.pid, // 网址传参--------------------------
				ets:ets,
				size: this.pageNum,
				offset: offsetTemp,
			}).then(res => {
				console.log("getStepListData-res.data.data:------- ", res.data.data);
				this.stepDataListData.isLoading = false;
 				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.stepDataListData.isNoData = true;
				} else {
					this.stepDataListData.isNoData = false;
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.stepDataListData.datajson = [];
						var tempMonthList = [];
						var newTime = '';
						this.stepDataListData.lastTimeFormat='';
						res.data.data.forEach((item, i) => {
							if ('' == this.stepDataListData.lastTimeFormat) {
								this.stepDataListData.lastTimeFormat = item.mtimeFormat.substring(0,4) + this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) + this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit');
								item.time = item.mtimeFormat.substring(11,13)+":00";
								tempMonthList.push(item);
							} else {
							
								if (this.stepDataListData.lastTimeFormat != (item.mtimeFormat.substring(0,4) + this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) +this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit'))) {
									this.stepDataListData.dataJson.push({
										'time': this.stepDataListData.lastTimeFormat,
										'stepDatas': tempMonthList
									});
									this.stepDataListData.lastTimeFormat = item.mtimeFormat.substring(0,4) + this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) + this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit');
									tempMonthList = [];
									item.time = item.mtimeFormat.substring(11,13)+":00";
									tempMonthList.push(item);

								} else {
									item.time = item.mtimeFormat.substring(11,13)+":00";
									tempMonthList.push(item);
								}
							}
							// console.log("forEach循环==i==    ", i, tempMonthList, this.stepDataListData.MonthDataListJson);
							if (i == length - 1) {
								this.stepDataListData.datajson.push({
									'time': this.stepDataListData.lastTimeFormat,
									'stepDatas': tempMonthList
								});
							}

						})
						this.stepDataListData.isShowBottom = false;
						this.stepDataListData.dataSize = length;

					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.stepDataListData.lastTimeFormat) {
								this.stepDataListData.lastTimeFormat = item.mtimeFormat.substring(0,4) + this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) + this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit');
								item.time = item.mtimeFormat.substring(11,13)+":00";
								tempMonthList.push(item);
							} else {
								if (this.stepDataListData.lastTimeFormat !=( item.mtimeFormat.substring(0,4) +this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) + this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.stepDataListData.datajson.push({
											'time': this.stepDataListData.lastTimeFormat,
											'stepDatas': tempMonthList
										});
									}
									this.stepDataListData.lastTimeFormat =item.mtimeFormat.substring(0,4) +this.$t('common.yearUnit') + item.mtimeFormat.substring(5,7) + this.$t('common.monthUnit')+ item.mtimeFormat.substring(8,10) + this.$t('common.dayUnit');
									tempMonthList = [];
									item.time =item.mtimeFormat.substring(11,13)+":00";
									tempMonthList.push(item);

								} else {
									tempMonthList = this.stepDataListData.datajson[this
										.stepDataListData.datajson.length - 1].stepDatas;
									item.time =item.mtimeFormat.substring(11,13)+":00";
									tempMonthList.push(item);
									this.stepDataListData.datajson[this.stepDataListData.datajson.length - 1].stepDatas = tempMonthList;
									tempMonthList = [];
								}
							}
							if (i == length - 1) {
								if (tempMonthList && tempMonthList.length > 0) {
									this.stepDataListData.datajson.push({
										'time': this.stepDataListData.lastTimeFormat,
										'stepDatas': tempMonthList
									});
								}
							}
							// console.log("forEach循环==i==    ", i, 'this.sportMonthListData.MonthDataListJson=', this.sportMonthListData.MonthDataListJson);
							// console.log("forEach循环==i==    ", i);
						})
						this.stepDataListData.isShowBottom = false;
						this.stepDataListData.dataSize = this.stepDataListData.dataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " + length, "<",this.pageNum,"   list  =", this.stepDataListData.dataJson);
						this.stepDataListData.isBottomNoMore = true;
						if(this.stepDataListData.dataJson.length==0){
							this.stepDataListData.isNoData = true;
						}
					}
				}
			});
		},
		getPressList(offsetTemp,ets) {
			getPressDataList({
				pid: this.$route.query.pid, // 网址传参--------------------------
				sts:ets,
				size: this.pageNum,
			}).then(res => {
				console.log("getPressData-res.data.data:------- ", res.data.data);
				this.pressDataListData.isLoading = false;
 				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.pressDataListData.isNoData = true;
				} else {
					this.pressDataListData.isNoData = false;
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.pressDataListData.datajson = [];
						var tempMonthList = [];
						var newTime = '';
						this.pressDataListData.lastTimeFormat='';
						res.data.data.forEach((item, i) => {
							if ('' == this.pressDataListData.lastTimeFormat) {
								this.pressDataListData.lastTimeFormat = time(item.sts).format( this.$t('common.formatDateYMD') );
								item.time = time(item.sts).format( this.$t('common.formatDateHM') );
								tempMonthList.push(item);
							} else {
							
								if (this.pressDataListData.lastTimeFormat != time(item.sts).format( this.$t('common.formatDateYMD') )) {
									this.pressDataListData.dataJson.push({
										'time': this.pressDataListData.lastTimeFormat,
										'pressDatas': tempMonthList
									});
									this.pressDataListData.lastTimeFormat = time(item.sts).format( this.$t('common.formatDateYMD') );
									tempMonthList = [];
									item.time = time(item.sts).format( this.$t('common.formatDateHM') );
									tempMonthList.push(item);

								} else {
									item.time = time(item.sts).format( this.$t('common.formatDateHM') );
									tempMonthList.push(item);
								}
							}
							// console.log("forEach循环==i==    ", i, tempMonthList, this.pressDataListData.MonthDataListJson);
							if (i == length - 1) {
								this.pressDataListData.datajson.push({
									'time': this.pressDataListData.lastTimeFormat,
									'pressDatas': tempMonthList
								});
							}

						})
						this.pressDataListData.isShowBottom = false;
						this.pressDataListData.dataSize = length;

					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.pressDataListData.lastTimeFormat) {
								this.pressDataListData.lastTimeFormat = time(item.sts).format( this.$t('common.formatDateYMD') );
								item.time = time(item.sts).format( this.$t('common.formatDateHM') );
								tempMonthList.push(item);
							} else {
								if (this.pressDataListData.lastTimeFormat !=time(item.sts).format( this.$t('common.formatDateYMD') )) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.pressDataListData.datajson.push({
											'time': this.pressDataListData.lastTimeFormat,
											'pressDatas': tempMonthList
										});
									}
									this.pressDataListData.lastTimeFormat =time(item.sts).format( this.$t('common.formatDateYMD') );
									tempMonthList = [];
									item.time =time(item.sts).format( this.$t('common.formatDateHM') );
									tempMonthList.push(item);

								} else {
									tempMonthList = this.pressDataListData.datajson[this
										.pressDataListData.datajson.length - 1].pressDatas;
									item.time =time(item.sts).format( this.$t('common.formatDateHM') );
									tempMonthList.push(item);
									this.pressDataListData.datajson[this.pressDataListData.datajson.length - 1].pressDatas = tempMonthList;
									tempMonthList = [];
								}
							}
							if (i == length - 1) {
								if (tempMonthList && tempMonthList.length > 0) {
									this.pressDataListData.datajson.push({
										'time': this.pressDataListData.lastTimeFormat,
										'pressDatas': tempMonthList
									});
								}
							}
							// console.log("forEach循环==i==    ", i, 'this.sportMonthListData.MonthDataListJson=', this.sportMonthListData.MonthDataListJson);
							// console.log("forEach循环==i==    ", i);
						})
						this.pressDataListData.isShowBottom = false;
						this.pressDataListData.dataSize = this.pressDataListData.dataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " + length, "<",this.pageNum,"   list  =", this.pressDataListData.dataJson);
						this.pressDataListData.isBottomNoMore = true;
						if(this.pressDataListData.dataJson.length==0){
							this.pressDataListData.isNoData = true;
						}
					}
				}
			});
		},
		getNibpReportDetail() {
			getNibpReportDetailData({
				rid: this.$route.query.rid, // 网址传参--------------------------
			}).then(res => {
				console.log("getNibpReportHistoryList-res:------- ", res);
				this.nibpReportDetailData = res.data.data;
				if (this.$route.path.includes('Liandai')) {
					this.nibpReportDetailDataColor.sysStatusColor = this.nibpReportDetailData.avgsysstatus == 1 ?
					'red1' : 'green3';
					this.nibpReportDetailDataColor.diaStatusColor = this.nibpReportDetailData.avgdiastatus == 1 ?
						'red1' : 'green3';
					this.nibpReportDetailDataColor.maxMinSysStatusColor = this.nibpReportDetailData
						.maxminsysstatus == 1 ? 'red1' : 'green3';
					this.nibpReportDetailDataColor.maxMinDiaStatusColor = this.nibpReportDetailData
						.maxmindiastatus == 1 ? 'red1' : 'green3';

					this.nibpReportDetailDataColor.sysLoad24hStatusColor = this.nibpReportDetailData
						.sysload24hstatus == 1 ? 'red1' : 'green3';
					this.nibpReportDetailDataColor.diaLoad24hStatusColor = this.nibpReportDetailData
						.diaload24hstatus == 1 ? 'red1' : 'green3';
					this.nibpReportDetailDataColor.sysLoadDayTimeStatusColor = this.nibpReportDetailData
						.sysloaddaytimestatus == 1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.diaLoadDayTimeStatusColor = this.nibpReportDetailData
						.dialoaddaytimestatus == 1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.sysLoadNightStatusColor = this.nibpReportDetailData
						.sysloadnightstatus == 1 ? 'red1' : 'green3';
					this.nibpReportDetailDataColor.diaLoadNightStatusColor = this.nibpReportDetailData
						.dialoadnightstatus == 1 ? 'red1' : 'green3';

					this.nibpReportDetailDataColor.nightSysDecRateStatusColor = this.nibpReportDetailData
						.nightsysdecratestatus == 1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.nightDiaDecRateStatusColor = this.nibpReportDetailData
						.nightdiadecratestatus == 1 ? 'red1' :
						'green3';

					this.nibpReportDetailDataColor.avgDongMaiStatusColor = this.nibpReportDetailData
						.avgdongmaistatus == 1 ? 'red1' : 'green3';


					this.nibpReportDetailDataColor.sysCv24hStatusColor = this.nibpReportDetailData.sbyxs24hstatus ==
						1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.diaCv24hStatusColor = this.nibpReportDetailData.dbyxs24hstatus ==
						1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.sysCvDayTimeStatusColor = this.nibpReportDetailData
						.sbyxsdtstatus == 1 ?
						'red1' :
						'green3';
					this.nibpReportDetailDataColor.diaCvDayTimeStatusColor = this.nibpReportDetailData
						.dbyxsdtstatus == 1 ?
						'red1' :
						'green3';
					this.nibpReportDetailDataColor.sysCvNightStatusColor = this.nibpReportDetailData.sbyxsnstatus ==
						1 ? 'red1' :
						'green3';
					this.nibpReportDetailDataColor.diaCvNightStatusColor = this.nibpReportDetailData.dbyxsnstatus ==
						1 ? 'red1' :
						'green3';

					this.nibpReportDetailDataColor.allNibpStatisticsColor = (this.nibpReportDetailData
						.avgsysstatus == 0 && this.nibpReportDetailData
							.avgdiastatus == 0 &&
						this.nibpReportDetailData.maxminsysstatus == 0 &&
						this.nibpReportDetailData.maxmindiastatus == 0 && this.nibpReportDetailData
							.sysload24hstatus == 0 && this
								.nibpReportDetailData.diaload24hstatus == 0 &&
						this.nibpReportDetailData.sysloaddaytimestatus == 0 && this.nibpReportDetailData
							.dialoaddaytimestatus == 0 &&
						this.nibpReportDetailData.sysloadnightstatus == 0 && this.nibpReportDetailData
							.dialoadnightstatus == 0 &&
						this.nibpReportDetailData.nightsysdecratestatus == 0 &&
						this.nibpReportDetailData.nightdiadecratestatus == 0 && this.nibpReportDetailData
							.avgdongmaistatus == 0 &&
						(this.nibpReportDetailData.sbyxs24hstatus == 0) && (this.nibpReportDetailData
							.dbyxs24hstatus == 0)
							(this.nibpReportDetailData.sbyxsdtstatus == 0) && (this.nibpReportDetailData
								.dbyxsdtstatus == 0)
							(this.nibpReportDetailData.sbyxsnstatus == 0) && (this.nibpReportDetailData
								.dbyxsnstatus == 0)) ? 'green3' : 'red1';
				}else{
					this.nibpReportDetailDataColor.sysStatusColor = this.nibpReportDetailData.avgsysstatus == 1 ?
						'red' : 'green';
					this.nibpReportDetailDataColor.diaStatusColor = this.nibpReportDetailData.avgdiastatus == 1 ?
						'red' : 'green';
					this.nibpReportDetailDataColor.maxMinSysStatusColor = this.nibpReportDetailData
						.maxminsysstatus == 1 ? 'red' : 'green';
					this.nibpReportDetailDataColor.maxMinDiaStatusColor = this.nibpReportDetailData
						.maxmindiastatus == 1 ? 'red' : 'green';

					this.nibpReportDetailDataColor.sysLoad24hStatusColor = this.nibpReportDetailData
						.sysload24hstatus == 1 ? 'red' : 'green';
					this.nibpReportDetailDataColor.diaLoad24hStatusColor = this.nibpReportDetailData
						.diaload24hstatus == 1 ? 'red' : 'green';
					this.nibpReportDetailDataColor.sysLoadDayTimeStatusColor = this.nibpReportDetailData
						.sysloaddaytimestatus == 1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.diaLoadDayTimeStatusColor = this.nibpReportDetailData
						.dialoaddaytimestatus == 1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.sysLoadNightStatusColor = this.nibpReportDetailData
						.sysloadnightstatus == 1 ? 'red' : 'green';
					this.nibpReportDetailDataColor.diaLoadNightStatusColor = this.nibpReportDetailData
						.dialoadnightstatus == 1 ? 'red' : 'green';

					this.nibpReportDetailDataColor.nightSysDecRateStatusColor = this.nibpReportDetailData
						.nightsysdecratestatus == 1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.nightDiaDecRateStatusColor = this.nibpReportDetailData
						.nightdiadecratestatus == 1 ? 'red' :
						'green';

					this.nibpReportDetailDataColor.avgDongMaiStatusColor = this.nibpReportDetailData
						.avgdongmaistatus == 1 ? 'red' : 'green';


					this.nibpReportDetailDataColor.sysCv24hStatusColor = this.nibpReportDetailData.sbyxs24hstatus ==
						1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.diaCv24hStatusColor = this.nibpReportDetailData.dbyxs24hstatus ==
						1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.sysCvDayTimeStatusColor = this.nibpReportDetailData
						.sbyxsdtstatus == 1 ?
						'red' :
						'green';
					this.nibpReportDetailDataColor.diaCvDayTimeStatusColor = this.nibpReportDetailData
						.dbyxsdtstatus == 1 ?
						'red' :
						'green';
					this.nibpReportDetailDataColor.sysCvNightStatusColor = this.nibpReportDetailData.sbyxsnstatus ==
						1 ? 'red' :
						'green';
					this.nibpReportDetailDataColor.diaCvNightStatusColor = this.nibpReportDetailData.dbyxsnstatus ==
						1 ? 'red' :
						'green';

					this.nibpReportDetailDataColor.allNibpStatisticsColor = (this.nibpReportDetailData
						.avgsysstatus == 0 && this.nibpReportDetailData
							.avgdiastatus == 0 &&
						this.nibpReportDetailData.maxminsysstatus == 0 &&
						this.nibpReportDetailData.maxmindiastatus == 0 && this.nibpReportDetailData
							.sysload24hstatus == 0 && this
								.nibpReportDetailData.diaload24hstatus == 0 &&
						this.nibpReportDetailData.sysloaddaytimestatus == 0 && this.nibpReportDetailData
							.dialoaddaytimestatus == 0 &&
						this.nibpReportDetailData.sysloadnightstatus == 0 && this.nibpReportDetailData
							.dialoadnightstatus == 0 &&
						this.nibpReportDetailData.nightsysdecratestatus == 0 &&
						this.nibpReportDetailData.nightdiadecratestatus == 0 && this.nibpReportDetailData
							.avgdongmaistatus == 0 &&
						(this.nibpReportDetailData.sbyxs24hstatus == 0) && (this.nibpReportDetailData
							.dbyxs24hstatus == 0)
							(this.nibpReportDetailData.sbyxsdtstatus == 0) && (this.nibpReportDetailData
								.dbyxsdtstatus == 0)
							(this.nibpReportDetailData.sbyxsnstatus == 0) && (this.nibpReportDetailData
								.dbyxsnstatus == 0)) ? 'green' : 'red';
				}
				let tmpDotStrs = res.data.data.datas;
					// let tmpDotStrs = "112,92,1619749424000;122,80,1619763824000;140,92,1619781824000;112,92,1619835824000;120,92,1619954624000;112,80,1620008624000;112,101,1620095024000;112,92,1620203024000;112,92,1620206624000;112,92,1620224624000";
					var tmpDotStrItems = tmpDotStrs.split(';');


					this.nibpReportPillardates = [];
					let startDate;
					for (var i = 0; i < 7; i++) {
						startDate = new Date(res.data.data.sts + i * 24 * 60 * 60 * 1000);
						this.nibpReportPillardates.push(startDate.getDate());
					}
					console.log("getNibpReportDetailData-nibpReportPillardates:------- ", this
						.nibpReportPillardates);
					let dots = tmpDotStrItems.map((currentValue, index, arr) => {
						let tmpDotItem = currentValue.split(',');
						// console.log("getNibpReportDetailData-tmpDotItem:------- ", tmpDotItem);
						return {
							x: this.xAxisComputeNibpReport(tmpDotItem[2], res.data.data.sts, res.data.data
								.ets, this.$refs
									.BPPillar.width),
							y: this.yAxisCompute(Math.round(tmpDotItem[1]), this.$refs
								.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
								this.$refs.BPPillar.height),
							y2: this.yAxisCompute(Math.round(tmpDotItem[0]), this.$refs
								.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
								this.$refs.BPPillar.height),
						}
					});
				// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
				this.BPDots = dots;
				console.log("getNibpReportDetailData-this.BPDots:------- ", this.BPDots);
				// console.log("this.BPDots心率-------------: ",this.BPDots);
				this.resetCanvas("BPCanvasOnoff");
			});
		},
		getNibpReportHistoryList() {
			getNibpReportHistoryListData({
				pid: this.$route.query.pid, // 网址传参--------------------------
			}).then(res => {
				console.log("getNibpReportHistoryList-res:------- ", res);
				// console.log("getNibpReportHistoryList-res:------- ", res.data.data);
				this.nibpReportListJson = res.data.data;
			});
		},

		getNewNibpReportTrend() {
			if(!this.nibpMeaStatistics.netLoading){
				this.nibpMeaStatistics.netLoading=true;
				this.resetReturnData('BP');
				getNewReportTrend({
					pid: this.$route.query.pid, // 网址传参--------------------------
					type: this.switchTime[this.returnTime.type],
					sts: this.returnTime.startTime,
					ets: this.returnTime.endTime,
				}).then(res => {
					console.log("getNewReportTrend-res:------- ", res);
					if (!res.data || !res.data.data) {
						// console.log("getNewReportTrend-res: error nodata------- ", res);
						this.BPDots = undefined;
						this.resetCanvas("BPCanvasOnoff");
						if (this.returnTime.type === '周') {
							this.nibpMeaStatistics.totalDays = 7; // 总天数或次数
							this.nibpMeaStatistics.tagetDayNum = 7; // 总天数或次数
						} else if (this.returnTime.type === '月') {
							var monthDayNum = getMonthDayNum(this.returnTime.startTime);
							this.nibpMeaStatistics.totalDays = monthDayNum; // 总天数或次数
							this.nibpMeaStatistics.tagetDayNum = monthDayNum; // 总天数或次数
						} else if (this.returnTime.type === '年') {
							var yearDayNum = getYearDayNum(new Date(this.returnTime.startTime).getFullYear());
							this.nibpMeaStatistics.totalDays = yearDayNum; // 总天数或次数
							this.nibpMeaStatistics.tagetDayNum = yearDayNum; // 总天数或次数
						}
						this.nibpInfoColor.isHideNibpStatusAnd = true;
						return false;
					}
					let dots = res.data.data.trendDataList;


					if (!dots) { // 没有数据的情况
						console.log("请求结果异常---------------");
						return false;
					}
					if (!this.$refs.BPPillar) { // 没有组件时的情况
						console.log("没有对应组件-------------");
						return false;
					} else if (dots.length > 0) {
						if (this.returnTime.type === '日') {
							dots = dots.map((currentValue, index, arr) => {
								return {
									x: this.xAxisCompute(currentValue.ts, this.returnTime.type, this.$refs
										.BPPillar.width),
									y: this.yAxisCompute(Math.round(currentValue.avgdia), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
									y2: this.yAxisCompute(Math.round(currentValue.avgsys), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
								}
							});
						} else {
							dots = dots.map((currentValue, index, arr) => {
								return {
									x: this.xAxisCompute(currentValue.ts, this.returnTime.type, this.$refs
										.BPPillar.width),
									y: this.yAxisCompute(Math.round(currentValue.mindia), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
									y2: this.yAxisCompute(Math.round(currentValue.maxdia), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
									y3: this.yAxisCompute(Math.round(currentValue.minsys), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
									y4: this.yAxisCompute(Math.round(currentValue.maxsys), this.$refs
										.BPPillar.yAxis[0], this.$refs.BPPillar.yAxis.slice(-1)[0],
										this.$refs.BPPillar.height),
								}
							});
						}
					}
					this.nibpInfoColor.isHideNibpStatusAnd = false;
					this.nibpMeaStatistics = res.data.data.meaStatistics;
					console.log("getNewReportTrend-this.nibpMeaStatistics:------- ", this.nibpMeaStatistics);
					this.nibpStatus = res.data.data.nibpStatus;
					console.log("getNewReportTrend-this.nibpStatus:------- ", this.nibpStatus);
					this.nibpStatistics = res.data.data.nibpStatistics;
					console.log("getNewReportTrend-this.nibpStatistics:------- ", this.nibpStatistics);
					console.log("getNewReportTrend-dots:------- ", dots);
					// 不同的图，点集不一样--------------------------------------------------------------------------------------------------------------------
					this.BPDots = dots;
					this.nibpMeaStatistics.netLoading=false;
					// console.log("this.BPDots心率-------------: ",this.BPDots);
					this.resetCanvas("BPCanvasOnoff");
					if (this.$route.path.includes('Liandai')) {
						this.updateUIByDataLiandai();
					}else{
						this.updateUIByData();
					}
				});
			}
		},
		getReportDayListDataSpo2(offsetTemp,category,measureWay){
			console.log(category + "-getMeasureDataDayList getReportDayListDataSpo2 measureWay:------- ", measureWay);
			getMeasureDataDayList({
				pid: this.$route.query.pid, // 网址传参--------------------------
				startNum: offsetTemp,
				size: 20,
				category:category,
				measureWay:measureWay,
			}).then(res => {
				// console.log(category + "-统计res:------- ",res);
				console.log(category + "-getMeasureDataDayList getReportDayListDataSpo2 res.data.data:------- ", res.data.data);
				
				this.BOListData.isLoading = false;
				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.BOListData.isNoData = true;
					this.BOListData.isShowBottom = false;
				} else {
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.BOListData.dayDataListJson = [];
						this.BOListData.lastTimeFormat ='';
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.BOListData.lastTimeFormat) {
								this.BOListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD')) ;
								item.time = time(item.sts).format("HH:mm:ss") ;
								tempMonthList.push(item);
							} else {
								console.log(this.BOListData.lastTimeFormat + "==i==    " + item.timeFromat);
								if (this.BOListData.lastTimeFormat != time(item.sts).format(this.$t('common.formatDateYMD'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.BOListData.dayDataListJson.push({
											'time': this.BOListData.lastTimeFormat,
											'nibps': tempMonthList
										});
									}
									this.BOListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									tempMonthList = [];
									item.time =  time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);

								} else {
									item.time = time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
								}
							}
							console.log("forEach循环==i==    ", i, tempMonthList, this.BOListData
								.dayDataListJson);
							if (i == length - 1) {
								this.BOListData.dayDataListJson.push({
									'time': this.BOListData.lastTimeFormat,
									'nibps': tempMonthList
								});
							}

						})
						this.BOListData.isShowBottom = false;
						this.BOListData.dayDataSize = length;
					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							//console.log(this.BOListData.lastTimeFormat + "==1111i==    " + item.timeFromat);
							if ('' == this.BOListData.lastTimeFormat) {
								this.BOListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD'));
								item.time =time(item.sts).format("HH:mm:ss");
								tempMonthList.push(item);
							} else {
								//console.log(this.BOListData.lastTimeFormat + "==i==    " +  time(item.sts).format(this.$t('common.formatDateYMD')));
								if (this.BOListData.lastTimeFormat !=  time(item.sts).format(this.$t('common.formatDateYMD'))) {
									// if (tempMonthList && tempMonthList.length > 0) {
									// 	this.BOListData.dayDataListJson.push({
									// 		'time': this.BOListData.lastTimeFormat,
									// 		'nibps': tempMonthList
									// 	});
									// }
									this.BOListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									tempMonthList = [];
									item.time = time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
									this.BOListData.dayDataListJson.push({
										'time': this.BOListData.lastTimeFormat,
										'nibps': tempMonthList
									});
								} else {
									if (tempMonthList && tempMonthList.length <= 0) {
										tempMonthList = this.BOListData.dayDataListJson[this.BOListData.dayDataListJson.length - 1].nibps;
									}
									item.time =time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
									// this.BOListData.dayDataListJson[this.BOListData.dayDataListJson.length - 1].nibps = tempMonthList;
									// tempMonthList = [];
								}
							}
							// if (i == length - 1) {
							// 	if (tempMonthList && tempMonthList.length > 0) {
							// 		this.BOListData.dayDataListJson.push({
							// 			'time': this.BOListData.lastTimeFormat,
							// 			'nibps': tempMonthList
							// 		});
							// 	}
							// }
							// console.log("forEach循环==i==    ", i);
						})
						this.BOListData.isShowBottom = false;
						this.BOListData.dayDataSize = this.BOListData.dayDataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " ,length,"<",this.pageNum);
						this.BOListData.isBottomNoMore = true;
					}
					// this.$forceUpdate();
				}
			});
		},
		getReportDayListDataHr(offsetTemp,category,measureWay){
			console.log(category + "-getMeasureDataDayList getReportDayListDataHr measureWay:------- ", measureWay);
			getMeasureDataDayList({
				pid: this.$route.query.pid, // 网址传参--------------------------
				startNum: offsetTemp,
				size: 20,
				category:category,
				measureWay:measureWay,
			}).then(res => {
				// console.log(category + "-统计res:------- ",res);
				console.log(category + "-getMeasureDataDayList getReportDayListDataHr res.data.data:------- ", res.data.data);
				
				this.HrListData.isLoading = false;
				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.HrListData.isNoData = true;
					this.HrListData.isShowBottom = false;
				} else {
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.HrListData.dayDataListJson = [];
						this.HrListData.lastTimeFormat ='';
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.HrListData.lastTimeFormat) {
								this.HrListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD')) ;
								item.time = time(item.sts).format("HH:mm:ss") ;
								//console.log(this.HrListData.lastTimeFormat + "=="+i+"=1=    " +time(item.sts).format(this.$t('common.formatDateYMD'))+ "   =    " +item.sts);
								tempMonthList.push(item);
							} else {
								//console.log(this.HrListData.lastTimeFormat + "=="+i+"=2=    " +time(item.sts).format(this.$t('common.formatDateYMD'))+ "   =    " +item.sts);
								if (this.HrListData.lastTimeFormat != time(item.sts).format(this.$t('common.formatDateYMD'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.HrListData.dayDataListJson.push({
											'time': this.HrListData.lastTimeFormat,
											'nibps': tempMonthList
										});
									}
									this.HrListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									tempMonthList = [];
									item.time =  time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);

								} else {
									item.time = time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
								}
							}
							//.log("forEach循环    ", i, tempMonthList, this.HrListData.dayDataListJson);
							if (i == length - 1) {
								this.HrListData.dayDataListJson.push({
									'time': this.HrListData.lastTimeFormat,
									'nibps': tempMonthList
								});
							}

						})
						this.HrListData.isShowBottom = false;
						this.HrListData.dayDataSize = length;
					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							//console.log(this.HrListData.lastTimeFormat + "=1="+i+"==    " + time(item.sts).format(this.$t('common.formatDateYMD'))+ "   =    " +item.sts);
							if ('' == this.HrListData.lastTimeFormat) {
								this.HrListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD'));
								item.time =time(item.sts).format("HH:mm:ss");
								tempMonthList.push(item);
							} else {
							//	console.log(this.HrListData.lastTimeFormat + "=2="+i+"==    " +  time(item.sts).format(this.$t('common.formatDateYMD'))+ "   =    " +item.sts);
								if (this.HrListData.lastTimeFormat !=  time(item.sts).format(this.$t('common.formatDateYMD'))) {
									// if (tempMonthList && tempMonthList.length > 0) {
									// 	this.HrListData.dayDataListJson.push({
									// 		'time': this.HrListData.lastTimeFormat,
									// 		'nibps': tempMonthList
									// 	});
									// 	console.log(this.HrListData.lastTimeFormat + "=3="+i+"==    " + this.HrListData.dayDataListJson );
									// }
									this.HrListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									//console.log(this.HrListData.lastTimeFormat + "=4="+i+"==    " );
									tempMonthList = [];
									item.time = time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
									this.HrListData.dayDataListJson.push({
										'time': this.HrListData.lastTimeFormat,
										'nibps': tempMonthList
									});

								} else {
									if (tempMonthList && tempMonthList.length <= 0) {
										tempMonthList = this.HrListData.dayDataListJson[this.HrListData.dayDataListJson.length - 1].nibps;
									}
									item.time =time(item.sts).format("HH:mm:ss");
									tempMonthList.push(item);
									//this.HrListData.dayDataListJson[this.HrListData.dayDataListJson.length - 1].nibps = tempMonthList;
									//tempMonthList = [];
								}
							}
							// if (i == length - 1) {
							// 	if (tempMonthList && tempMonthList.length > 0) {
							// 		this.HrListData.dayDataListJson.push({
							// 			'time': this.HrListData.lastTimeFormat,
							// 			'nibps': tempMonthList
							// 		});
							// 	}
							// }
							// console.log("forEach循环==i==    ", i);
						})
						this.HrListData.isShowBottom = false;
						this.HrListData.dayDataSize = this.HrListData.dayDataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " ,length,"<",this.pageNum);
						this.HrListData.isBottomNoMore = true;
					}
					// this.$forceUpdate();
				}
			});
		},
		getReportDayListDataBodyTemp(offsetTemp,category,measureWay){
			console.log(category + "-getMeasureDataDayList getReportDayListDataBodyTemp measureWay:------- ", measureWay);
			getMeasureDataDayList({
				pid: this.$route.query.pid, // 网址传参--------------------------
				startNum: offsetTemp,
				size: 20,
				category:category,
				measureWay:measureWay,
			}).then(res => {
				// console.log(category + "-统计res:------- ",res);
				console.log(category + "-getMeasureDataDayList getReportDayListDataBodyTemp res.data.data:------- ", res.data.data);
				
				this.TemperatureListData.isLoading = false;
				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.TemperatureListData.isNoData = true;
					this.TemperatureListData.isShowBottom = false;
				} else {
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.TemperatureListData.dayDataListJson = [];
						this.TemperatureListData.lastTimeFormat ='';
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.TemperatureListData.lastTimeFormat) {
								this.TemperatureListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD')) ;
								item.time = time(item.sts).format("HH:mm:ss") ;
								if(item.bodyheat>1000){
									item.bodytempStr=item.bodyheat/100;
								}else{
									item.bodytempStr=item.bodyheat/10;
								}
								tempMonthList.push(item);
							} else {
								//console.log(this.TemperatureListData.lastTimeFormat + "==i==    " + item.timeFromat);
								if (this.TemperatureListData.lastTimeFormat != time(item.sts).format(this.$t('common.formatDateYMD'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.TemperatureListData.dayDataListJson.push({
											'time': this.TemperatureListData.lastTimeFormat,
											'nibps': tempMonthList
										});
									}
									this.TemperatureListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									tempMonthList = [];
									item.time =  time(item.sts).format("HH:mm:ss");
									if(item.bodyheat>1000){
										item.bodytempStr=item.bodyheat/100;
									}else{
										item.bodytempStr=item.bodyheat/10;
									}
									tempMonthList.push(item);

								} else {
									item.time = time(item.sts).format("HH:mm:ss");
									if(item.bodyheat>1000){
										item.bodytempStr=item.bodyheat/100;
									}else{
										item.bodytempStr=item.bodyheat/10;
									}
									tempMonthList.push(item);
								}
							}
							//console.log("forEach循环==i==    ", i, tempMonthList, this.TemperatureListData.dayDataListJson);
							if (i == length - 1) {
								this.TemperatureListData.dayDataListJson.push({
									'time': this.TemperatureListData.lastTimeFormat,
									'nibps': tempMonthList
								});
							}

						})
						this.TemperatureListData.isShowBottom = false;
						this.TemperatureListData.dayDataSize = length;
					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							//console.log(this.TemperatureListData.lastTimeFormat + "==1111i==    " + item.timeFromat);
							if ('' == this.TemperatureListData.lastTimeFormat) {
								this.TemperatureListData.lastTimeFormat =  time(item.sts).format(this.$t('common.formatDateYMD'));
								item.time =time(item.sts).format("HH:mm:ss");
								if(item.bodyheat>1000){
									item.bodytempStr=item.bodyheat/100;
								}else{
									item.bodytempStr=item.bodyheat/10;
								}
								tempMonthList.push(item);
							} else {
								//console.log(this.TemperatureListData.lastTimeFormat + "==i==    " +  time(item.sts).format(this.$t('common.formatDateYMD')));
								if (this.TemperatureListData.lastTimeFormat !=  time(item.sts).format(this.$t('common.formatDateYMD'))) {
									// if (tempMonthList && tempMonthList.length > 0) {
									// 	this.TemperatureListData.dayDataListJson.push({
									// 		'time': this.TemperatureListData.lastTimeFormat,
									// 		'nibps': tempMonthList
									// 	});
									// }
									this.TemperatureListData.lastTimeFormat = time(item.sts).format(this.$t('common.formatDateYMD'));
									tempMonthList = [];
									item.time = time(item.sts).format("HH:mm:ss");
									if(item.bodyheat>1000){
										item.bodytempStr=item.bodyheat/100;
									}else{
										item.bodytempStr=item.bodyheat/10;
									}
									tempMonthList.push(item);
									this.TemperatureListData.dayDataListJson.push({
										'time': this.TemperatureListData.lastTimeFormat,
										'nibps': tempMonthList
									});
								} else {
									if (tempMonthList && tempMonthList.length <= 0) {
										tempMonthList = this.TemperatureListData.dayDataListJson[this.TemperatureListData.dayDataListJson.length - 1].nibps;
									}
									item.time =time(item.sts).format("HH:mm:ss");
									if(item.bodyheat>1000){
										item.bodytempStr=item.bodyheat/100;
									}else{
										item.bodytempStr=item.bodyheat/10;
									}
									tempMonthList.push(item);
									// this.TemperatureListData.dayDataListJson[this.TemperatureListData.dayDataListJson.length - 1].nibps = tempMonthList;
									// tempMonthList = [];
								}
							}
							// if (i == length - 1) {
							// 	if (tempMonthList && tempMonthList.length > 0) {
							// 		this.TemperatureListData.dayDataListJson.push({
							// 			'time': this.TemperatureListData.lastTimeFormat,
							// 			'nibps': tempMonthList
							// 		});
							// 	}
							// }
							// console.log("forEach循环==i==    ", i);
						})
						this.TemperatureListData.isShowBottom = false;
						this.TemperatureListData.dayDataSize = this.TemperatureListData.dayDataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " ,length,"<",this.pageNum);
						this.TemperatureListData.isBottomNoMore = true;
					}
					// this.$forceUpdate();
				}
			});
		},

		getReportDayListDataByCategory(offsetTemp,category){
			let str=category;
			if(this.$route.query.vtoken){
				this.$store.state.vtoken = this.$route.query.vtoken || "";
			}
			let measureWay=0;
			if(this.$route.query.measureWay){
				measureWay=this.$route.query.measureWay;
			}
			console.log("getReportDayListDataByCategory this.$route.query.vtoken: ", this.$route.query.vtoken);
			if(category=='BO'){
				this.getReportDayListDataSpo2(offsetTemp,'spo2',measureWay)
			}else if(category=='HR'){
				this.getReportDayListDataHr(offsetTemp,'hr',measureWay)
			}else if(category=='bodytemp'){
				this.getReportDayListDataBodyTemp(offsetTemp,'bodytemp',measureWay)
			}
		},

		// 获取月的详情列表
		getNewReportMonthData(offsetTemp) {
			console.log("getNewReportMonthData-res:------- ", offsetTemp);
			getNewReportMonthData({
				pid: this.$route.query.pid, // 网址传参--------------------------
				size: this.pageNum,
				offset: offsetTemp
			}).then(res => {
				console.log("getNewReportMonthData-res.data.data:------- ", res.data.data);
				this.monthListData.isLoading = false;

				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.monthListData.isNoData = true;
				} else {
					var length = res.data.data.length;
					if (offsetTemp == 0) {
						this.monthListData.MonthDataListJson = [];
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							if ('' == this.monthListData.lastTimeFormat) {
								this.monthListData.lastTimeFormat = item.timeFromat.substring(0, 4) +this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) + this.$t('common.monthUnitLast');
								item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
								tempMonthList.push(item);
							} else {
								//console.log(this.monthListData.lastTimeFormat + "==i==    " + item.timeFromat);
								if (this.monthListData.lastTimeFormat != (item.timeFromat.substring(0,4) + this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) +  this.$t('common.monthUnitLast'))) {
									if (tempMonthList && tempMonthList.length > 0) {
										this.monthListData.MonthDataListJson.push({
											'time': this.monthListData.lastTimeFormat,
											'nibps': tempMonthList
										});
									}
									this.monthListData.lastTimeFormat = item.timeFromat.substring(0,4) + this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) +  this.$t('common.monthUnitLast');
									tempMonthList = [];
									item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
									tempMonthList.push(item);

								} else {
									item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
									tempMonthList.push(item);
								}
							}
							//console.log("forEach循环==i==    ", i, tempMonthList, this.monthListData.MonthDataListJson);
							if (i == length - 1) {
								this.monthListData.MonthDataListJson.push({
									'time': this.monthListData.lastTimeFormat,
									'nibps': tempMonthList
								});
							}

						})
						this.monthListData.isShowBottom = false;
						this.monthListData.monthDataSize = length;
					} else {
						var tempMonthList = [];
						var newTime = '';
						res.data.data.forEach((item, i) => {
							//console.log(this.monthListData.lastTimeFormat + "==1111i==    " + item.timeFromat);
							if ('' == this.monthListData.lastTimeFormat) {
								this.monthListData.lastTimeFormat = item.timeFromat.substring(0, 4) +this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) + this.$t('common.monthUnitLast');
								item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
								tempMonthList.push(item);
							} else {
								//console.log(this.monthListData.lastTimeFormat + "==i==    " + (item.timeFromat.substring(0, 4) + this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) +  this.$t('common.monthUnitLast')));
								if (this.monthListData.lastTimeFormat != (item.timeFromat.substring(0,4) + this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) + this.$t('common.monthUnitLast'))) {
									// if (tempMonthList && tempMonthList.length > 0) {
									// 	this.monthListData.MonthDataListJson.push({
									// 		'time': this.monthListData.lastTimeFormat,
									// 		'nibps': tempMonthList
									// 	});
									// }
									this.monthListData.lastTimeFormat = item.timeFromat.substring(0,4) + this.$t('common.yearUnit') + item.timeFromat.substring(5, 7) +  this.$t('common.monthUnitLast');
									tempMonthList = [];
									item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
									tempMonthList.push(item);
									this.monthListData.MonthDataListJson.push({
										'time': this.monthListData.lastTimeFormat,
										'nibps': tempMonthList
									});

								} else {
									if (tempMonthList && tempMonthList.length <= 0) {
										tempMonthList = this.monthListData.MonthDataListJson[this.monthListData.MonthDataListJson.length - 1].nibps;
									}
									item.time = item.timeFromat.substring(5, 7) + this.$t('common.monthUnit') + item.timeFromat.substring(8, 10) + this.$t('common.dayUnit');
									tempMonthList.push(item);
									// this.monthListData.MonthDataListJson[this.monthListData.MonthDataListJson.length - 1].nibps = tempMonthList;
									// tempMonthList = [];
								}
							}
							// if (i == length - 1) {
							// 	if (tempMonthList && tempMonthList.length > 0) {
							// 		this.monthListData.MonthDataListJson.push({
							// 			'time': this.monthListData.lastTimeFormat,
							// 			'nibps': tempMonthList
							// 		});
							// 	}
							// }
							// console.log("forEach循环==i==    ", i);
						})
						this.monthListData.isShowBottom = false;
						this.monthListData.monthDataSize = this.monthListData.monthDataSize + length;
					}

					if (length < this.pageNum) {
						console.log("==no more==length=    " ,length,"<",this.pageNum);
						this.monthListData.isBottomNoMore = true;
					}
					// this.$forceUpdate();
					// console.log("this.monthListData.MonthDataListJson    ", this.monthListData.MonthDataListJson);
				}
			});

		},
		updateNibpReportApplyFailData(data) {
			this.visibleReportDays = data;
		},
		// 获取日的详情列表
		getNewReportDayData(timeFromatV) {
			console.log("getNewReportDayData-res:------- ");
			getNewReportDayData({
				pid: this.$route.query.pid, // 网址传参--------------------------
				timeFromat: timeFromatV
			}).then(res => {
				console.log("getNewReportDayData-res.data.data:------- ", res.data.data);
				this.nibpDayListData.isLoading = false;

				if (undefined == res || undefined == res.data || undefined == res.data.data) {
					this.nibpDayListData.isNoData = true;
				} else {
					this.nibpDayListData.dayListJson = res.data.data;
					// console.log("this.nibpDayListData.dayListJson    ", this.nibpDayListData.dayListJson);
				}
				// this.$forceUpdate();
			});

		},
		// 步数统计
		getStatistics(category = 'SN') {
			if (!(category == 'SN' || category == 'nibp' || category == 'spo2' || category == 'hr' || category ==
				'hrv_num' || category == 'bodytemp')) {
				alert("趋势类型参数错误");
			} else if (category == 'SN') {
				getStatistics({
					pid: this.$route.query.pid, // 网址传参--------------------------
					type: 'statistics',
					extend: 1, // 网址传参--------------------------
					sts: this.returnTime.startTime,
					ets: this.returnTime.endTime
				}).then(res => {
					// console.log(category + "-统计res:------- ",res);
					console.log(category + "-统计res.data.data:------- ", res.data.data);

					this.statistics = res.data.data;
					console.log("this.statistics: ", this.statistics);
				});

			}

		},
		// 获取血氧白分比
		getBOPercentage() {
			console.log("this.$route.query.vtoken: ", this.$route.query.vtoken);

			getBOPercentage({
				pid: this.$route.query.pid,
				// [this.$route.query.vtoken ? 'category' : 'core']:'spo2',
				[this.$route.query.vtoken ? 'category' : 'category']: 'spo2',
				sts: this.returnTime.startTime,
				ets: this.returnTime.endTime
			}).then(res => {
				console.log("血氧健康白分比res.data.data: ", res.data.data);
				this.BOPercentage = res.data.data;
			})
		},
		// 获取血氧白分比
		getBOPercentageType(type) {
			console.log("this.$route.query.vtoken: ", this.$route.query.vtoken);

			getBOPercentage({
				pid: this.$route.query.pid,
				// [this.$route.query.vtoken ? 'category' : 'core']:'spo2',
				[this.$route.query.vtoken ? 'category' : 'category']: 'spo2',
				sts: this.returnTime.startTime,
				ets: this.returnTime.endTime,
				measureWay:type
			}).then(res => {
				console.log("血氧健康白分比res.data.data: ", res.data.data);
				if(type==1){
					this.BOCSPercentage = res.data.data;
				}else{
					this.BOPercentage = res.data.data;
				}
			})
		},
		// 初始化canvas显示
		resetCanvas(canvasOnoff, ms = 50, callback) {
			this[canvasOnoff] = false;

			let timer = setTimeout(() => {
				this[canvasOnoff] = true;
				if (callback) callback();

				clearTimeout(timer);
			}, ms);
		},
		// 初始化数据（绘图组件返回的数据、请求的数据）
		resetReturnData(type) {
			if (type == 'SN') {
				this.returnDataSN = {};
				// 步数统计
				this.statistics = {
					stepsAvg: 0,
					stepsSum: 0
				};
			} else if (type == 'BP') {
				this.returnDataBP = {};
				// 血压测量统计meaStatistics
				this.nibpMeaStatistics = {
					netLoading:false,//网络请求
					totalDays: 0, // 总天数或次数
					tagetDayNum: 0, //目标次数或者天数
					totalNum: 0, //测量总天数或次数
					totalStatus: 0, // 0未达标 1 达标(总测量)
					time6to8count: 0, //6到8点测量次数
					time17to19count: 0, //，测量次数
					time20to24count: 0, //20点到24点测量次数
					time6to8countStatus: 0, // 0为达标 1 达标
					time17to19countStatus: 0, // 0为达标 1 达标
					time20to24countStatus: 0, // 0为达标 1 达标
				};

				this.nibpStatus = {
					normalCount: 0, //正常血压次数
					normalHighCount: 0, //正常高值血压次数
					normalHighStatus: 0, // 0正常1异常
					highCount: 0, //高血压次数
					highStatus: 0, //0正常1异常
					oneLevelCount: 0, //一级高血压次数
					oneLevelStatus: 0, //0正常1异常
					twoLevelCount: 0, //二级高血压次数
					twoLevelStatus: 0, //0正常1异常
				};
				// 血压统计meaStatistics
				this.nibpStatistics = {
					avgSys: 0, //高压平均值
					sysRefer: "< 130", //高压参考值
					sysStatus: 0, //0正常1异常
					avgDia: 0, //低压平均值
					diaRefer: "< 85", //低压参考值
					diaStatus: 0, //0正常1异常
					maxSys: 0, //高压最大值
					maxDia: 0, //低压最大值
					minSys: 0, //高压最小值
					minDia: 0, //低压最小值
					maxMinSysStatus: 0, //0正常1异常	
					maxMinDiaStatus: 0, //0正常1异常			

					sysLoadDayTime: 0, //白天高压负荷,//
					sysLoadDayTimeStatus: 0, //0正常1异常  白天
					diaLoadDayTime: 0, //低压负荷 白天，
					diaLoadDayTimeStatus: 0, //0正常1异常 白天
					sysLoadNight: 0, //高压负荷 夜间,//
					sysLoadNightStatus: 0, //0正常1异常
					diaLoadNight: 0, //低压负荷 夜间，
					diaLoadNightStatus: 0, //0正常1异常
					sysLoad24h: 0, //高压负荷,//
					sysLoad24hStatus: 0, //0正常1异常
					diaLoad24h: 0, //低压负荷，
					diaLoad24hStatus: 0, //0正常1异常
					loadRefer: 0, //负荷参考值, //

					nightSysDecRate: 0, // 夜间高压下降率
					nightSysDecRateStatus: 0, //0正常1异常
					nightDiaDecRate: 0, //夜间低压下降率
					nightDiaDecRateStatus: 0, //0正常1异常
					decRateRefer: ">=10% , <=20%", // <=20%，下降率参考值
					avgDongMai: 0, //平均动脉压
					avgDongMaiStatus: 0, //0正常1异常

					//变异系数
					coefficient24: {
						sys24: "0", //高压变异系数
						sys24OfDiff: "0", //标准差
						dia24: "0", //低压变异系数
						dia24OfDiff: "0", //标准差
					},
					coefficientDaytime: {
						sys24: "0", //高压变异系数
						sys24OfDiff: "0", //标准差
						dia24: "0", //低压变异系数
						dia24OfDiff: "0", //标准差
					},
					coefficientNight: {
						sys24: "0", //高压变异系数
						sys24OfDiff: "0", //标准差
						dia24: "0", //低压变异系数
						dia24OfDiff: "0", //标准差
					},
				};
				if (this.$route.path.includes('Liandai')) {
					this.updateUIByDataLiandai();
				}else{
					this.updateUIByData();
				}
			} else if (type == 'BO') {
				this.returnDataBO = {};
				// 血氧白分比
				this.BOPercentage = {
					abnormal: 0,
					all: 0,
					normal: 0,
				};
				this.returnDataCSBO = {};
				// 血氧白分比
				this.BOCSPercentage = {
					abnormal: 0,
					all: 0,
					normal: 0,
				};
			} else if (type == 'HR') {
				this.returnDataHR = {};
				this.returnDataCSHR = {};
			} else if (type == 'P') {
				this.returnDataP = {};
			} else if (type == 'T') {
				this.returnDataT = {};
			}else if(type == 'Sport'){
				this.returnDataSportHR = {};
				this.returnDataSportStep = {};
				this.returnDataSportPace = {};
			} else if (type == 'Sleep') {
				this.returnDataSleep = {
					data: {
						sleepDate: ''
					}
				};
				this.SleepReport = {
					yLimit: [0, 2, 4, 6, 8, 10, 12],
					sleepTimeSecond: 0,
					deepSleepSecond: 0,
					lightSleepSecond: 0,
					remSleepSecond: 0,
					sleepContinue: 0,
					sleepWakeNum: 0,
					sleepBreath: 0,
					sleepBeginPercent: 0,
					sleepBeginTime: 0,
					sleepEndPercent: 0,
					sleepEndTime: 0,
				}
				// console.log("returnDataSleep=",this.returnDataSleep)
			}
		},
		updateUIByDataLiandai() {

			this.nibpInfoColor.totalStatusColor = this.nibpMeaStatistics.totalStatus == 0 ? this.red1 : this.green3;
			this.nibpInfoColor.time6to8countStatusColor = this.nibpMeaStatistics.time6to8countStatus == 0 ? this.red1 :
				this.green3;
			this.nibpInfoColor.time17to19countStatusColor = this.nibpMeaStatistics.time17to19countStatus == 0 ? this.red1 :
				this.green3;
			this.nibpInfoColor.time20to24countStatusColor = this.nibpMeaStatistics.time20to24countStatus == 0 ? this.red1 :
				this.green3;



			this.nibpInfoColor.normalHighStatusColor = this.nibpStatus.normalHighStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.highStatusColor = this.nibpStatus.highStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.oneLevelStatusColor = this.nibpStatus.oneLevelStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.twoLevelStatusColor = this.nibpStatus.twoLevelStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.allNibpStatusColor = (this.nibpStatus.normalHighStatus == 0 &&
				this.nibpStatus.highStatus == 0 && this.nibpStatus.oneLevelStatus == 0 &&
				this.nibpStatus.twoLevelStatus == 0) ? this.green3 : this.red1;




			this.nibpInfoColor.sysStatusColor = this.nibpStatistics.sysStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.diaStatusColor = this.nibpStatistics.diaStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.maxMinSysStatusColor = this.nibpStatistics.maxMinSysStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.maxMinDiaStatusColor = this.nibpStatistics.maxMinDiaStatus == 1 ? this.red1 : this.green3;


			this.nibpInfoColor.sysLoad24hStatusColor = this.nibpStatistics.sysLoad24hStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.diaLoad24hStatusColor = this.nibpStatistics.diaLoad24hStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.sysLoadDayTimeStatusColor = this.nibpStatistics.sysLoadDayTimeStatus == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.diaLoadDayTimeStatusColor = this.nibpStatistics.diaLoadDayTimeStatus == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.sysLoadNightStatusColor = this.nibpStatistics.sysLoadNightStatus == 1 ? this.red1 : this.green3;
			this.nibpInfoColor.diaLoadNightStatusColor = this.nibpStatistics.diaLoadNightStatus == 1 ? this.red1 : this.green3;

			this.nibpInfoColor.nightSysDecRateStatusColor = this.nibpStatistics.nightSysDecRateStatus == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.nightDiaDecRateStatusColor = this.nibpStatistics.nightDiaDecRateStatus == 1 ? this.red1 :
				this.green3;

			this.nibpInfoColor.avgDongMaiStatusColor = this.nibpStatistics.avgDongMaiStatus == 1 ? this.red1 : this.green3;


			this.nibpInfoColor.sysCv24hStatusColor = this.nibpStatistics.coefficient24.sys24Status == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.diaCv24hStatusColor = this.nibpStatistics.coefficient24.dia24Status == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.sysCvDayTimeStatusColor = this.nibpStatistics.coefficientDaytime.sys24Status == 1 ?
				this.red1 :
				this.green3;
			this.nibpInfoColor.diaCvDayTimeStatusColor = this.nibpStatistics.coefficientDaytime.dia24Status == 1 ?
				this.red1 :
				this.green3;
			this.nibpInfoColor.sysCvNightStatusColor = this.nibpStatistics.coefficientNight.sys24Status == 1 ? this.red1 :
				this.green3;
			this.nibpInfoColor.diaCvNightStatusColor = this.nibpStatistics.coefficientNight.dia24Status == 1 ? this.red1 :
				this.green3;

			this.nibpInfoColor.allNibpStatisticsColor = (this.nibpStatistics.sysStatus == 0 && this.nibpStatistics
				.diaStatus == 0 &&
				this.nibpStatistics.maxMinSysStatus == 0 &&
				this.nibpStatistics.maxMinDiaStatus == 0 && this.nibpStatistics.sysLoad24hStatus == 0 && this
					.nibpStatistics.diaLoad24hStatus == 0 &&
				this.nibpStatistics.sysLoadDayTimeStatus == 0 && this.nibpStatistics.diaLoadDayTimeStatus == 0 &&
				this.nibpStatistics.sysLoadNightStatus == 0 && this.nibpStatistics.diaLoadNightStatus == 0 &&
				this.nibpStatistics.nightSysDecRateStatus == 0 &&
				this.nibpStatistics.nightDiaDecRateStatus == 0 && this.nibpStatistics.avgDongMaiStatus == 0 &&
				(this.nibpStatistics.coefficient24.sys24Status == 0) && (this.nibpStatistics.coefficient24
					.dia24Status == 0)
					(this.nibpStatistics.coefficientDaytime.sys24Status == 0) && (this.nibpStatistics.coefficientDaytime
						.dia24Status == 0)
					(this.nibpStatistics.coefficientNight.sys24Status == 0) && (this.nibpStatistics.coefficientNight
						.dia24Status == 0)) ? this.green3 : this.red1;
		},
		updateUIByData() {

			this.nibpInfoColor.totalStatusColor = this.nibpMeaStatistics.totalStatus == 0 ? 'red' : 'green';
			this.nibpInfoColor.time6to8countStatusColor = this.nibpMeaStatistics.time6to8countStatus == 0 ? 'red' :
				'green';
			this.nibpInfoColor.time17to19countStatusColor = this.nibpMeaStatistics.time17to19countStatus == 0 ? 'red' :
				'green';
			this.nibpInfoColor.time20to24countStatusColor = this.nibpMeaStatistics.time20to24countStatus == 0 ? 'red' :
				'green';



			this.nibpInfoColor.normalHighStatusColor = this.nibpStatus.normalHighStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.highStatusColor = this.nibpStatus.highStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.oneLevelStatusColor = this.nibpStatus.oneLevelStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.twoLevelStatusColor = this.nibpStatus.twoLevelStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.allNibpStatusColor = (this.nibpStatus.normalHighStatus == 0 &&
				this.nibpStatus.highStatus == 0 && this.nibpStatus.oneLevelStatus == 0 &&
				this.nibpStatus.twoLevelStatus == 0) ? 'green' : 'red';




			this.nibpInfoColor.sysStatusColor = this.nibpStatistics.sysStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.diaStatusColor = this.nibpStatistics.diaStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.maxMinSysStatusColor = this.nibpStatistics.maxMinSysStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.maxMinDiaStatusColor = this.nibpStatistics.maxMinDiaStatus == 1 ? 'red' : 'green';


			this.nibpInfoColor.sysLoad24hStatusColor = this.nibpStatistics.sysLoad24hStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.diaLoad24hStatusColor = this.nibpStatistics.diaLoad24hStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.sysLoadDayTimeStatusColor = this.nibpStatistics.sysLoadDayTimeStatus == 1 ? 'red' :
				'green';
			this.nibpInfoColor.diaLoadDayTimeStatusColor = this.nibpStatistics.diaLoadDayTimeStatus == 1 ? 'red' :
				'green';
			this.nibpInfoColor.sysLoadNightStatusColor = this.nibpStatistics.sysLoadNightStatus == 1 ? 'red' : 'green';
			this.nibpInfoColor.diaLoadNightStatusColor = this.nibpStatistics.diaLoadNightStatus == 1 ? 'red' : 'green';

			this.nibpInfoColor.nightSysDecRateStatusColor = this.nibpStatistics.nightSysDecRateStatus == 1 ? 'red' :
				'green';
			this.nibpInfoColor.nightDiaDecRateStatusColor = this.nibpStatistics.nightDiaDecRateStatus == 1 ? 'red' :
				'green';

			this.nibpInfoColor.avgDongMaiStatusColor = this.nibpStatistics.avgDongMaiStatus == 1 ? 'red' : 'green';


			this.nibpInfoColor.sysCv24hStatusColor = this.nibpStatistics.coefficient24.sys24Status == 1 ? 'red' :
				'green';
			this.nibpInfoColor.diaCv24hStatusColor = this.nibpStatistics.coefficient24.dia24Status == 1 ? 'red' :
				'green';
			this.nibpInfoColor.sysCvDayTimeStatusColor = this.nibpStatistics.coefficientDaytime.sys24Status == 1 ?
				'red' :
				'green';
			this.nibpInfoColor.diaCvDayTimeStatusColor = this.nibpStatistics.coefficientDaytime.dia24Status == 1 ?
				'red' :
				'green';
			this.nibpInfoColor.sysCvNightStatusColor = this.nibpStatistics.coefficientNight.sys24Status == 1 ? 'red' :
				'green';
			this.nibpInfoColor.diaCvNightStatusColor = this.nibpStatistics.coefficientNight.dia24Status == 1 ? 'red' :
				'green';

			this.nibpInfoColor.allNibpStatisticsColor = (this.nibpStatistics.sysStatus == 0 && this.nibpStatistics
				.diaStatus == 0 &&
				this.nibpStatistics.maxMinSysStatus == 0 &&
				this.nibpStatistics.maxMinDiaStatus == 0 && this.nibpStatistics.sysLoad24hStatus == 0 && this
					.nibpStatistics.diaLoad24hStatus == 0 &&
				this.nibpStatistics.sysLoadDayTimeStatus == 0 && this.nibpStatistics.diaLoadDayTimeStatus == 0 &&
				this.nibpStatistics.sysLoadNightStatus == 0 && this.nibpStatistics.diaLoadNightStatus == 0 &&
				this.nibpStatistics.nightSysDecRateStatus == 0 &&
				this.nibpStatistics.nightDiaDecRateStatus == 0 && this.nibpStatistics.avgDongMaiStatus == 0 &&
				(this.nibpStatistics.coefficient24.sys24Status == 0) && (this.nibpStatistics.coefficient24
					.dia24Status == 0)
					(this.nibpStatistics.coefficientDaytime.sys24Status == 0) && (this.nibpStatistics.coefficientDaytime
						.dia24Status == 0)
					(this.nibpStatistics.coefficientNight.sys24Status == 0) && (this.nibpStatistics.coefficientNight
						.dia24Status == 0)) ? 'green' : 'red';
		},
		changeLanguage(lan){
			this.$i18n.locale = lan
			console.log('changeLanguage'+lan)
			localStorage.setItem('lang',lan)
		},
		// 自定义事件，子组件返回数据到父组件：不同的图，自定义事件触发时绑定的函数不同--------------------------------------------------------------------------------
		/*sendData(params){
			this.returnData = {  ...params  };
		},*/
		sendDataBP(params) {
			this.returnDataBP = {
				...params
			};
		},
		sendDataSleep(params) {
			this.returnDataSleep = {
				...params
			};
		},
		sendDataBO(params) {
			this.returnDataBO = {
				...params
			};
		},
		sendDataCSBO(params) {
			this.returnDataCSBO = {
				...params
			};
		},
		sendDataSN(params) {
			this.returnDataSN = {
				...params
			};
		},
		sendDataHR(params) {
			this.returnDataHR = {
				...params
			};
		},
		sendDataCSHR(params) {
			this.returnDataCSHR = {
				...params
			};
		},
		sendDataSportHR(params) {
			this.returnDataSportHR = {
				...params
			};
		},
		sendDataSportStep(params) {
			this.returnDataSportStep = {
				...params
			};
		},
		sendDataSportPace(params) {
			this.returnDataSportPace = {
				...params
			};
		},
		sendDataP(params) {
			this.returnDataP = {
				...params
			};
		},
		sendDataT(params) {
			this.returnDataT = {
				...params
			};
			// console.log("this.returnDataT-----: ",this.returnDataT);
		},

	},
	created() {
		console.log("this.$route.query.vtoken: ", this.$route.query.vtoken);
		this.$store.state.vtoken = this.$route.query.vtoken || "";


		// 统一控制颜色
		let colorJson = {
			orange: ['#dfdfdf', '#fe8888', '#999999', '#f82828', '#f57d31', 'red', '#fed5d5',
				'#fe8888'
			], // [gray,lightRed,gray2,red]    时间组件颜色    曲线颜色、渐变色、渐变色[red,lightRed2,lightRed]
			yellow: ['#dfdfdf', '#87d687', '#999999', 'rgba(26,173,25,1)', 'rgba(26,173,25,1)', 'rgba(26,173,25,1)',
				'rgba(26,173,25,0.2)', 'rgba(26,173,25,1)'
			], // [gray,lightGreen,gray2,green]
			yellow2: ['#dfdfdf', '#b8dec8', '#999999', '#5cb180', '#5cb180', '#5cb180', 'rgba(26,173,25,0.2)',
				'#5cb180'
			], //   [gray,lightGreen2,gray2,green2]
			blue: ['#dfdfdf', '#33beff', '#999999', '#4987c4', '#4987c4', '#4987c4', '#33beff',
				'#4987c4'
			], //   [gray,lightBlue,gray2,blue]
			liandai: ['#dfdfdf', '#00cf66', '#999999', '#00A652', '#00cf66', '#00cf66', '#00A652',
				'#00cf66'
			], //
		};

		console.log("this.$route.path-------------------------: ", this.$route.path,this.$route.path.includes('Liandai'));
		if (this.$route.path.includes('2')) {
			this.colorArr = colorJson['yellow'];
		} else if (this.$route.path.includes('3')) {
			this.colorArr = colorJson['yellow2'];
			console.log("this.$route.path1111  yellow2-------------------------: ", this.$route.path);
		} else if (this.$route.path.includes('4')) {
			this.colorArr = colorJson['blue']; 
		} else if (this.$route.path.includes('Liandai')) {
			console.log("this.$route.path1111-------------------------: ", this.$route.path);
			this.colorArr = colorJson['liandai'];
		} else {
			this.colorArr = colorJson['orange'];
		}

	},
	mounted() {
		console.log("this.$route.path-------------------------: ", this.$route.path);
		// if (!this.$route.query.pid && this.$route.path != '/userAgreement'&& this.$route.path != '/privacy'&& this.$route.path != '/guide/video'&&this.$route.path.indexOf('/guide/')==-1
		// && this.$route.path != '/guide/warn'&& this.$route.path != '/guide/nibpIndex'&& this.$route.path != '/guide/index'&& this.$route.path != '/guide/suanHuaTagNibpIndex') {
		
		if (!this.$route.query.pid && this.$route.path != '/userAgreement'&&this.$route.path.indexOf('privacy')==-1&& this.$route.path != '/privacy'&& this.$route.path != '/luonengprivacy'&&this.$route.path.indexOf('/deleteAccountUrl')==-1&&this.$route.path.indexOf('/guide/')==-1&&this.$route.path.indexOf('/measureDetails')==-1) {
			alert("请传入参数‘pid’");
		}
		if (this.$route.query.language && this.$route.query.language== 'en'){
			this.changeLanguage('en');
		}else if(this.$route.query.language && this.$route.query.language== 'ja_JP'){
			this.changeLanguage('ja_JP');
		}else if(this.$route.query.language && this.$route.query.language== 'kk'){
			this.changeLanguage('kk');
		}else if(this.$route.query.language && this.$route.query.language== 'ru'){
			this.changeLanguage('ru');
		}else{
			this.changeLanguage('zh');
		}
	}
}
